(() => {
  // 本文件自己的 URL，用来拼同源 asset 路径。
  // 必须在顶层同步取，defer 脚本执行完 currentScript 就没了。
  const ASSET_BASE = (() => {
    const self =
      document.currentScript ||
      document.querySelector('script[src*="global-component.js"]');
    return self && self.src ? self.src.replace(/[^/]+(\?.*)?$/, "") : "";
  })();

  function debounce(fn, delay3) {
    let timer = null;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fn.apply(this, args);
      }, delay3);
    };
  }
  window._debounce = debounce;

  // header.style.top 的所有权标志。
  // slide-navs 与 header-navigation 都会在滚动时改 header 的 top，
  // 前者藏整个 header，后者只藏公告条，同时写会互相覆盖。
  // slide-navs 存在时由它独占，header-navigation 让出控制权。
  let slideNavsOwnsHeaderTop = false;

  window.addEventListener(
    "resize",
    debounce(() => {
      document.dispatchEvent(new CustomEvent("windowResize"));
    }, 300)
  );

  // 公共类可继承open属性
  const GlobalHTMLElement = class extends HTMLElement {
    static get observedAttributes() {
      return ["open"];
    }
    constructor() {
      super();
    }
    get open() {
      return this.hasAttribute("open");
    }
    set open(value) {
      if (value) {
        this.setAttribute("open", "");
      } else {
        this.removeAttribute("open");
      }
    }
    listenerKeydown() {
      document.addEventListener("keydown", (e) => {
        if (this.open && e.code == "Escape") {
          this.open = false;
          document.body.classList.remove("overflow-hidden");
        }
      });
    }
  };
  // swiper-component 自定义轮播组件
  customElements.define(
    "swiper-component",
    class SwiperComponent extends GlobalHTMLElement {
      custom_pagination = {
        total: 0,
        current: 0,
      };
      swiper_options = {
        slidesPerView: 1,
        spaceBetween: 40,
        loop: false,
        autoplay: false,
        watchOverflow: true,
      };
      constructor() {
        super();
        // 执行一次
        this.lock = true;
        // 自定义切换按钮
        this.custom_prev_btn = this.querySelector(".swiper-pagination-prev");
        this.custom_next_btn = this.querySelector(".swiper-pagination-next");
        this.custom_swiper_tabs = this.querySelectorAll(".swiper-tab-item");
      }
      disconnectedCallback() {
        this.swiper.destroy(true, true);
      }
      attributeChangedCallback(name, oldValue, newValue) {
        switch (name) {
          case "open":
            if (this.hasAttribute("open") && this.lock) {
              this.lock = false;
              this.startSwiper();
            }
        }
      }
      startSwiper() {
        this.initPagination();
        this.initSwiper();
        // 自定义切换按钮
        this.initCuPaginationButton();
      }

      initSwiper() {
        Object.keys(this.dataset).forEach((key) => {
          this.swiper_options[key] = JSON.parse(this.dataset[key]);
        });
        this.swiper = new Swiper(this.querySelector(".swiper"), {
          ...this.swiper_options,
        });
        this.swiper["custom_pagination"] = this.custom_pagination;
        this.swiper.on("slideChange", (item) => {
          this.custom_pagination["current"] = item.realIndex + 1;
          this.swiper["custom_pagination"] = this.custom_pagination;
          this.updateCuPaginationButton();
          this.selectTabsItem(item.realIndex);
          this.initVideoLazyLoad(item.activeIndex);
        });


        if (this.dataset.progress) {
          this.querySelector(".swiper").classList.add("swiper-autoplay");
          this.swiper.on("autoplayTimeLeft", (s, time, progress) => {
            this.style.setProperty(
              `--pagination-progress`,
              ((1 - progress) * 100).toFixed(0) + "%"
            );
            // 你可以将 progress 用于进度条或圆环展示
          });
        }
      }
      slideTo(index) {
        this.swiper.slideTo(index);
      }

      initVideoLazyLoad(index) {
        this.timeout && clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          if (!this.swiper.slides[index]) return;
          if (!this.swiper.slides[index].querySelectorAll("video").length) return;
          this.swiper.slides[index].querySelectorAll("video").forEach((video) => {
            video.play();
          })
          this.swiper.slides.filter(slide => slide != this.swiper.slides[index]).forEach((t) => {
            t.querySelectorAll("video").forEach((video) => {
              video.pause();
            })
          })
        }, 300)

      }

      initPagination() {
        if (
          this.querySelector(".swiper-button-next") &&
          this.querySelector(".swiper-button-prev")
        ) {
          this.swiper_options.navigation = {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          };
        }
        if (this.querySelector(".swiper-pagination")) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          };
        }
        if (
          this.querySelector(
            ".swiper-pagination.swiper-pagination-dynamicBullets"
          )
        ) {
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
            dynamicBullets: true,
          };
        }
        if (this.querySelector(".swiper-pagination-custom")) {
          const _this = this;
          this.swiper_options.pagination = {
            el: this.querySelector(".swiper-pagination-custom"),
            clickable: true,
            type: "custom",
            renderCustom: function (swiper, current, total) {
              _this.custom_pagination = {
                current,
                total,
              };
              return null;
            },
          };
        }
      }
      initCuPaginationButton() {
        if (this.custom_next_btn && this.custom_prev_btn) {
          this.updateCuPaginationButton();
          this.custom_prev_btn.onclick = () => {
            this.swiper.slidePrev();
            this.updateCuPaginationButton();
          };
          this.custom_next_btn.onclick = () => {
            this.swiper.slideNext();
            this.updateCuPaginationButton();
          };
        }
        if (this.custom_swiper_tabs.length) {
          this.selectTabsItem(this.swiper_options.initialSlide ?? 0);
          this.custom_swiper_tabs.forEach((item, index) => {
            item.onclick = () => {
              this.swiper.slideTo(index);
              this.selectTabsItem(index);
            };
          });
        }
      }

      selectTabsItem(index) {
        if (this.custom_swiper_tabs.length) {
          $(this.custom_swiper_tabs)
            .not(this.custom_swiper_tabs[index])
            .removeClass("active");
          // slide 数可能多于 tab 数（如兜底 slide），越界时只清空高亮不报错
          const tab = this.custom_swiper_tabs[index];
          if (tab) tab.classList.add("active");
        }
      }
      updateCuPaginationButton() {
        if (!this.custom_next_btn && !this.custom_prev_btn) return;
        this.custom_prev_btn.disabled = this.swiper.activeIndex == 0;
        this.custom_next_btn.disabled = this.swiper.isEnd;
      }
    }
  );

  // 轮播图上下切换按钮组件(含当前页数)
  customElements.define(
    "swiper-button-pagination",
    class SwiperComponent extends HTMLElement {
      constructor() {
        super();
        this.swiper =
          document.getElementById(this.dataset.sectionId)?.swiper ?? {};
        this.current_dom = this.querySelector(
          ".swiper-button-pagination-current"
        );
        this.total_dom = this.querySelector(".swiper-button-pagination-total");
        this.prev_btn = this.querySelector(".swiper-button-pagination-prev");
        this.next_btn = this.querySelector(".swiper-button-pagination-next");
        this.selectActive();
        this.init();
      }

      init() {
        this.prev_btn.addEventListener("click", () => {
          this.swiper.slidePrev();
        });
        this.next_btn.addEventListener("click", () => {
          this.swiper.slideNext();
        });
        this.swiper.on("slideChange", (item) => {
          this.selectActive();
        });

        window.addEventListener(
          "resize",
          debounce(() => {
            this.selectActive();
          }, 400)
        );
      }
      selectActive() {
        this.current_dom.innerText = this.swiper.custom_pagination.current;
        this.total_dom.innerText = this.swiper.custom_pagination.total;
        this.prev_btn.disabled = this.swiper.activeIndex == 0;
        this.next_btn.disabled = this.swiper.isEnd;
      }
    }
  );

  /**
   * 唤醒弹窗按钮有两种唤醒方式
   * 1. global-modal-button子元素包含template
   * 2. global-modal-button data-id 不为空
   *
   * */

  customElements.define(
    "global-modal-button",
    class GlobalModalButton extends HTMLElement {
      constructor() {
        super();
        this.childHtml = this.querySelector("template")?.innerHTML;
        this.modalContainer = null;
        this.boundClick = null;
        this.boundBackdrop = null;
      }
      connectedCallback() {
        if (!this.childHtml && !this.dataset.modalId) return;
        this.addEventListener("click", this.openGlobalModalHandle);
      }
      openGlobalModalHandle() {
        if (this.childHtml) {
          document.dispatchEvent(
            new CustomEvent("open-global-modal", {
              bubbles: true,
              detail: {
                childHtml: this.childHtml,
                contentClass: this.dataset.contentClass,
              },
            })
          );
          return;
        }

        if (!this.modalContainer) {
          this.modalContainer = document.getElementById(this.dataset.modalId);
          if (!this.modalContainer) return;

          const close = this.modalContainer.querySelector('.close-modal');
          if (close) {
            close.addEventListener('click', () => this.closeModal());
          }

          this.modalContainer.addEventListener("click", (e) => {
            if (e.target === this.modalContainer) this.closeModal();
          });
        }

        this.openModal();
        if (this.dataset.index) {
          this.modalContainer.slideTo(this.dataset.index);
        }
      }
      openModal() {
        this.modalContainer.setAttribute("open", "");
        document.body.classList.add("overflow-hidden");
      }
      closeModal() {
        this.modalContainer.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
      }
      disconnectedCallback() {
        this.removeEventListener("click", this.openGlobalModalHandle);
      }
    }
  );


  customElements.define('global-modal-close', class GlobalModalClose extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.addEventListener("click", this.closeGlobalModal);
    }
    closeGlobalModal() {
      document.dispatchEvent(
        new CustomEvent('close-global-modal', {
          bubbles: true,
        })
      );
      const anchor = document.getElementById(this.dataset.anchor);
      if (!anchor) return
      anchor.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
        block: 'start'      // 对齐到顶部
      });
    }
  })

  customElements.define(
    "global-modal",
    class GlobalModal extends GlobalHTMLElement {
      constructor() {
        super();
        this.childHtml = null
        this.modalContent = this.querySelector(".global-modal-content")
        // 关闭按钮挪进内容区，定位到内容区右上角（.global-modal-content 本身是 relative）
        this.closeBtn = this.querySelector(".global-modal-close")
        this.mountCloseBtn()
        this.listenerKeydown();
      }
      listenerKeydown() {
        document.addEventListener("keydown", (e) => {
          if (this.open && e.code == "Escape") {
            this.removeContent();
          }
        });
      }
      mountCloseBtn() {
        if (this.closeBtn && this.modalContent && this.closeBtn.parentNode !== this.modalContent) {
          this.modalContent.prepend(this.closeBtn)
        }
      }
      connectedCallback() {
        this.addEventListener("click", (e) => {
          // closest：点到图标内部的 path 也算点关闭
          if (this.open && (e.target == this || (this.closeBtn && e.target.closest?.('.global-modal-close') === this.closeBtn))) {
            this.removeContent()
          }
        });
        document.addEventListener("open-global-modal", (e) => {
          if (this.childHtml != e.detail.childHtml) {
            this.childHtml = e.detail.childHtml
            this.modalContent.innerHTML = e.detail.childHtml;
            // innerHTML 会把关闭按钮一起清掉，重新挂回去
            this.mountCloseBtn()
            e.detail.contentClass && this.modalContent.classList.add(e.detail.contentClass)
          }
          this._closing = false;
          this.open = true;
          document.body.classList.add("overflow-hidden")
        })
        document.addEventListener("close-global-modal", (e) => {
          this.removeContent()
        })
      }

      removeContent() {
        if (!this.open || this._closing) return;
        this._closing = true;
        this.open = false;
        const finish = () => {
          if (!this._closing) return;
          this._closing = false;
          document.body.classList.remove("overflow-hidden");
        };
        const onEnd = (e) => {
          if (e.target !== this || e.propertyName !== "opacity") return;
          this.removeEventListener("transitionend", onEnd);
          finish();
        };
        this.addEventListener("transitionend", onEnd);
        window.setTimeout(() => {
          this.removeEventListener("transitionend", onEnd);
          finish();
        }, 280);
      }
    }
  );

  // 加购按钮
  customElements.define(
    "add-cart-button",
    class AddCartButton extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.addEventListener("click", () => {
          if (this.hasAttribute("disabled")) return;
          this.addToCart(this.dataset.variantId, this.dataset.freebieId);
        });
      }
      addToCart(variantId, freebieId) {
        const _this = this;
        let formData = {
          items: [
            {
              id: Number(variantId),
              quantity: 1,
            },
          ],
        };

        // data-extra-ids：逗号分隔的额外变体 id，供多选加购场景一次加多件。
        // 不带该属性时行为与原来完全一致。
        const extraIds = (this.dataset.extraIds || "")
          .split(",")
          .map((v) => Number(v.trim()))
          .filter((v) => v && v !== Number(variantId));
        extraIds.forEach((id) => formData.items.push({ id, quantity: 1 }));

        // 添加赠品
        freebieId &&
          formData.items.unshift({ id: Number(freebieId), quantity: 1 });

        this.classList.add("button-loading");
        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((res) => {
            document.dispatchEvent(
              new CustomEvent("main-cart:render", {
                bubbles: true,
              })
            );
          })
          .catch((error) => {
            console.error("Error:", error);
            alert("Error", JSON.stringify(error));
          })
          .finally(() => {
            _this.classList.remove("button-loading");
          });
      }
    }
  );

  customElements.define(
    "image-lazy-load",
    class ImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.image = this.querySelector(".img--lazyload");
        this.initImageLazyLoad();
      }

      initImageLazyLoad() {
        if ("IntersectionObserver" in window) {
          const lazyImageObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                let lazyImage = entry.target;
                lazyImage.src = lazyImage.dataset.src;
                lazyImage.classList.add("lazyloaded");
                observer.unobserve(entry.target);
                // 重新计算动画位置
                // AOS?.refreshHard()
              }
            });
          });

          lazyImageObserver.observe(this.image);
        } else {
          let active = false;
          const _this = this;
          let lazyLoad = () => {
            if (active === false) {
              active = true;
              setTimeout(() => {
                const lazyImage = _this.image;
                if (
                  lazyImage.getBoundingClientRect().top <= window.innerHeight &&
                  lazyImage.getBoundingClientRect().bottom >= 0 &&
                  getComputedStyle(lazyImage).display !== "none"
                ) {
                  lazyImage.src = lazyImage.dataset.src;
                  // lazyImage.classList.remove("lazy");
                  lazyImage.classList.add("lazyloaded");
                }
                active = false;
              }, 200);
            }
          };
          document.addEventListener("scroll", lazyLoad);
          window.addEventListener("resize", lazyLoad);
          window.addEventListener("orientationchange", lazyLoad);
        }
      }
    }
  );
  customElements.define(
    "bg-image-lazy-load",
    class BgImageLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.bgElements = this.querySelectorAll(".bg-lazyload");
        this.init();
      }
      init() {
        if ("IntersectionObserver" in window) {
          const lazyObserver = new IntersectionObserver(function (
            entries,
            observer
          ) {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                let element = entry.target;
                element.style.backgroundImage = `url(${element.dataset.src})`;
                observer.unobserve(entry.target);
              }
            });
          });
          this.bgElements.forEach((item) => {
            lazyObserver.observe(item);
          });
        } else {
          this.bgElements.forEach((item) => {
            item.style.backgroundImage = `url(${item.dataset.src})`;
          });
        }
      }
    }
  );
  class VideoLazyLoad extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.video = this.querySelector(".video--lazyLoad");
      // 人机是否有交互
      this.interactState = false;
      this.autoplayMap = [];
      // this.listenerIntersectionObserver()
      this.listenerInteract();
      this.listenerALick();
      if (this.hasAttribute("data-hover-play")) {
        this.listenerHoverPlay();
      }
    }

    listenerIntersectionObserver() {
      const _this = this;
      this.videoObserver = new IntersectionObserver(function (
        entries,
        observer
      ) {
        entries.forEach((entry) => {
          let video = entry.target;
          if (entry.isIntersecting) {
            video.src = video.dataset.src;
            if (video.dataset.poster) {
              video.poster = video.dataset.poster;
            }
            if (video.dataset.autoplay) {
              // 有交互性则自动播放
              video.play();
              // _this.interactState ? video.play() : _this.autoplayMap.push(video)
            }

            // observer.unobserve(entry.target);
          } else {
            // 不在可视区暂停播放
            video.src && video.pause();
          }
        });
      });

      this.videoObserver.observe(this.video);
      //   this.videos.forEach((item) => {
      //     this.videoObserver.observe(item);
      //   });
    }
    listenerInteract() {
      const startEvent = () => {
        this.listenerIntersectionObserver();
        // this.interactState = true
        // this.autoplayMap.forEach(video => video.play())
      };
      document.addEventListener("mousemove", startEvent, { once: true });
      document.addEventListener("touchstart", startEvent, { once: true });
    }

    listenerALick() {
      document.addEventListener("click", (event) => {
        if (
          event.target.tagName === "A" &&
          event.target.getAttribute("href") &&
          this.video
        ) {
          //   this.videos.forEach((video) => video.pause());
          this.video.pause();
        }
      });
    }

    listenerHoverPlay() {
      this.addEventListener("mouseenter", () => {
        if (!this.video) return;
        this.video.muted = true;
        this.video.play().catch(() => { });
      });
      this.addEventListener("mouseleave", () => {
        if (this.video) this.video.pause();
      });
    }
  }
  customElements.define("video-lazy-load", VideoLazyLoad);

  customElements.define(
    "global-tabs",
    class GlobalTabs extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.tabs = Array.from(this.querySelectorAll(".global-tab"));
        this.swiperContainer = document.querySelector(
          "#" + this.dataset.swiperId
        )?.swiper;
        this.tabsSwiper = this.querySelector("swiper-component")?.swiper ?? {};

        this.swiperContainer.on("slideChange", (e) => {
          this.slideTo(e.activeIndex);
        });
        this.tabsSwiper.on("tap", (e) => {
          this.slideTo(e.clickedIndex);
        });
        this.slideTo(0);
      }
      slideTo(i) {
        let index = Number(i ?? 0);
        let currentSlide = this.tabs[index];
        this.swiperContainer.slideTo(index);
        this.tabsSwiper.slideTo(index);
        this.tabs
          .filter((t) => t != currentSlide)
          .forEach((t) => t.classList.remove("active"));
        currentSlide.classList.add("active");
      }
      updateSlider() { }
    }
  );
  customElements.define(
    "subscribe-email",
    class SubscribeEmail extends HTMLElement {
      constructor() {
        super();
        if (this.dataset.isSticky == "true") {
          this.sticky_container = this.parentNode;
          this.setParentStyle();
          this.init();
        }
      }
      setParentStyle() {
        this.sticky_container.style.cssText =
          "position: sticky;top: 0;z-index: 10;";
      }
      init() {
        let intervalCount = 0;
        let time = setInterval(() => {
          let epb_background = document.querySelector("#epb_background");
          intervalCount++;
          if (epb_background || intervalCount >= 30) {
            if (
              epb_background &&
              ["fixed", "sticky"].includes(epb_background.style.position)
            ) {
              this.listenerRpbCountdownCreate(epb_background);
            }
            clearInterval(time);
          }
        }, 1000);
      }

      listenerRpbCountdownCreate(epb_background) {
        let sticky_top = epb_background.getBoundingClientRect()?.height ?? 0;
        this.sticky_container.style.top = sticky_top + "px";
        epb_background
          .querySelector("#epb_close")
          ?.addEventListener("click", () => {
            this.sticky_container.style.top = 0;
          });
      }
    }
  );

  customElements.define(
    "faq-conetnt",
    class FaqConetnt extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        const itemTitles = this.querySelectorAll(".section-faq-item-title");
        itemTitles.forEach((item) => {
          item.addEventListener("click", () => {
            item.classList.toggle("active");
            $(item.nextElementSibling).slideToggle();
          });
        });
      }
    }
  );
  customElements.define(
    "youtube-lazy-load",
    class YoutubeLazyLoad extends HTMLElement {
      constructor() {
        super();
        this.youtubeSection = this.querySelector(".youtube-lazy--section");
        this.createScript();
        document.addEventListener("youTubeReady", () => {
          this.scrollView();
        });
      }
      scrollView() {
        const _this = this;
        const observer = new IntersectionObserver(function (entries, observer) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!entry.target.playVideo) {
                _this.init(entry.target);
              }
            } else {
              entry.target.pauseVideo?.();
            }
          });
        });
        observer.observe(this.youtubeSection);
      }
      init(section) {
        if (section.playVideo) return;
        if (window.YT) {
          const target = section.querySelector(".youtube-lazy--load");
          const playe = new window.YT.Player(target, {
            ...target.dataset,
          });
          section.playVideo = function () {
            playe.playVideo?.();
          };
          section.pauseVideo = function () {
            playe.pauseVideo?.();
          };
        }
      }
      disconnectedCallback() {
        // this.modalContainer.removeEventListener("click")
      }

      createScript() {
        const scriptTags = Array.from(document.getElementsByTagName("script"));
        const youtubeScript = scriptTags.find(
          (t) => t.src == "https://www.youtube.com/player_api"
        );
        if (!youtubeScript) {
          let tag = document.createElement("script");
          tag.src = "https://www.youtube.com/player_api";
          scriptTags[0].parentNode.insertBefore(tag, scriptTags[0]);
        } else {
          this.scrollView(this);
        }
      }
    }
  );

  customElements.define(
    "slide-navs",
    class SlideNavs extends HTMLElement {
      constructor() {
        super();
        this.swiper = this.querySelector("swiper-component")?.swiper ?? {};
        this.header = document.querySelector(".header__container");
        this.navContainer = document.querySelector(".slide-navs__container");
        this.targetElements = Array.from(
          document.querySelectorAll(".section-anchor-target")
        );
        // 声明 header.style.top 由本组件独占，让 header-navigation 让出控制权
        if (this.header) slideNavsOwnsHeaderTop = true;
        this.activeIndex = -1;
        this.curScrollY = this.getScrollTop();
        this.isScrollingDown = null;
        this.pendingDown = null;
        this.accDelta = 0;
        this.rafId = null;
        this.init();
        this.listenerScroll();
      }
      init() {
        this.slides = Array.from(this.querySelectorAll(".slide-navs--item"));
        this.slides.forEach((t, index) => {
          t.onclick = () => {
            this.toTarget(index);
          };
        });
        this.selectActive(0);
      }
      selectActive(index) {
        // index 没变就跳过，避免重复写 DOM 和重启 swiper 动画
        if (index === this.activeIndex) return;
        const currentItem = this.slides[index];
        if (!currentItem) return;
        const prevItem = this.slides[this.activeIndex];
        prevItem?.classList.remove("active");
        currentItem.classList.add("active");
        this.activeIndex = index;
        this.swiper?.slideTo?.(index);
      }
      listenerScroll() {
        // rAF 节流：连续滚动时每帧最多跑一次，且与浏览器绘制节奏对齐
        window.addEventListener(
          "scroll",
          () => {
            if (this.rafId !== null) return;
            this.rafId = requestAnimationFrame(() => {
              this.rafId = null;
              this.onScroll();
            });
          },
          { passive: true }
        );
      }
      onScroll() {
        // 先集中读取布局信息，再统一写样式，避免强制同步布局
        let nextIndex = this.activeIndex;
        for (let i = this.targetElements.length - 1; i >= 0; i--) {
          if (this.targetElements[i].getBoundingClientRect().top < 500) {
            nextIndex = i;
            break;
          }
        }
        const scrollY = this.getScrollTop();
        const delta = scrollY - this.curScrollY;
        this.curScrollY = scrollY;

        this.selectActive(nextIndex);

        if (!this.header || delta === 0) return;

        const scrollingDown = delta > 0;
        // 换向时重新累计，同向则累加：rAF 下单帧位移很小，靠累计量过阈值
        if (scrollingDown !== this.pendingDown) {
          this.pendingDown = scrollingDown;
          this.accDelta = 0;
        }
        this.accDelta += Math.abs(delta);

        // 累计滚动超过 6px 且方向与当前状态不同，才切换头部显隐
        if (this.accDelta > 6 && scrollingDown !== this.isScrollingDown) {
          this.isScrollingDown = scrollingDown;
          this.accDelta = 0;
          this.updateElementTopValue(scrollingDown);
        }
      }
      updateElementTopValue(scrollingDown) {
        // 与 header-navigation 统一使用 offsetHeight，包含 border，避免收起后露边
        const headerHeight = this.header.offsetHeight;
        if (scrollingDown) {
          if (this.navContainer) this.navContainer.style.top = "0px";
          this.header.style.top = `-${headerHeight}px`;
        } else {
          this.header.style.top = "0px";
          if (this.navContainer) {
            this.navContainer.style.top = `${headerHeight}px`;
          }
        }
      }
      getScrollTop() {
        return (
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.scrollY ||
          0
        );
      }
      toTarget(index) {
        const anchor = this.targetElements[index];
        anchor && anchor.scrollIntoView({ block: "start", behavior: "smooth" });
      }
    }
  );
  customElements.define(
    "content-slides",
    class ContentSlides extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const swiperContainer = document.querySelector(
          "#" + this.dataset.swiperId
        )?.swiper;

        const swiper = this.querySelector("swiper-component").swiper;

        swiperContainer.on("slideChange", (e) => {
          // this.updateSlider(this.tabs[e.activeIndex]);
          swiper.slideTo(e.activeIndex);
        });
      }
    }
  );

  customElements.define(
    "product-params-modal",
    class ProductParamsModal extends HTMLElement {
      constructor() {
        super();
        // this.closeBtn = this.querySelector(".close-modal");
        this.init();
      }
      init() {
        if (!this.id) return;
        // this.closeBtn.onclick = () => {
        //   this.closeModla();
        // };
        this.navSwiper = this.querySelector("#nav-" + this.id).swiper;
        this.slides = this.navSwiper.slides;
        this.contentSwiper = this.querySelector("#content-" + this.id).swiper;
        this.navSwiper.on("tap", (swiper) => {
          this.slideTo(swiper.clickedIndex);
        });
      }
      slideTo(i) {
        let index = Number(i ?? 0);
        let currentSlide = this.slides[index];
        this.navSwiper.slideTo(index);
        this.contentSwiper.slideTo(index);
        this.slides
          .filter((t) => t != currentSlide)
          .forEach((t) => t.classList.remove("active"));
        currentSlide.classList.add("active");
      }
      closeModla() {
        this.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
      }
    }
  );

  /**
   * 数字滚动
   * data-target
   */
  customElements.define(
    "scroll-number",
    class ScrollNumber extends HTMLElement {
      constructor() {
        super();
        // 滚动时长
        this.duration = 4000;
        this.init();
      }
      init() {
        this.querySelectorAll(".count--number").forEach((element) => {
          const number = parseInt(element.dataset.number ?? 0, 10);
          const duration = parseInt(
            element.dataset.duration ?? this.duration,
            10
          );
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  if (element.dataset.type) {
                    element.style.setProperty(
                      `--number-${element.dataset.type}`,
                      "100%"
                    );
                  } else {
                    this.animateNumber(entry.target, number, duration);
                  }
                  // observer.unobserve(entry.target); // 触发后取消观察
                } else {
                  element.style.setProperty(
                    `--number-${element.dataset.type}`,
                    "0%"
                  );
                }
              });
            },
            { threshold: 0.5 }
          ); // 当元素 50% 进入视口时触发

          observer.observe(element);
        });
      }
      animateNumber(element, number, duration) {
        let startTimestamp = null;

        // 缓动函数集合
        const easingFunctions = {
          // 默认线性（无缓动）
          linear: (progress) => progress,

          // 加速后减速（标准缓动）
          easeInOutQuad: (progress) => {
            return progress < 0.5
              ? 2 * progress * progress
              : 1 - Math.pow(-2 * progress + 2, 2) / 2;
          },

          // 结尾减速（常用效果）
          easeOutQuad: (progress) => {
            return 1 - (1 - progress) * (1 - progress);
          },

          // 弹性效果
          easeOutElastic: (progress) => {
            const c4 = (2 * Math.PI) / 3;
            return progress === 0
              ? 0
              : progress === 1
                ? 1
                : Math.pow(2, -10 * progress) *
                Math.sin((progress * 10 - 0.75) * c4) +
                1;
          },
        };

        const updateNumber = (timestamp) => {
          if (!startTimestamp) startTimestamp = timestamp;

          const elapsed = timestamp - startTimestamp;
          const rawProgress = Math.min(elapsed / duration, 1);

          // 使用缓动函数（这里选择 easeOutQuad）
          const easedProgress = easingFunctions.easeInOutQuad(rawProgress);
          const current = Math.floor(easedProgress * number);

          this.updateElement(element, current);
          if (rawProgress < 1) {
            requestAnimationFrame(updateNumber);
          } else {
            this.updateElement(element, number);
          }
        };
        requestAnimationFrame(updateNumber);
      }
      updateElement(element, number) {
        if (element.dataset.type) {
          element.style.setProperty(
            `--number-${element.dataset.type}`,
            number + "%"
          );
        } else {
          element.textContent = number;
        }
      }
    }
  );

  customElements.define(
    "return-top",
    class ReturnTop extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        this.onclick = () => {
          document.body.scrollIntoView({ block: "start", behavior: "smooth" });
        };
        document.addEventListener("scroll", () => {
          this.getScrollTop() >= 300
            ? this.classList.remove("return-top-hidden")
            : this.classList.add("return-top-hidden");
        });
      }
      getScrollTop() {
        return (
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          window.scrollY ||
          0
        );
      }
    }
  );

  customElements.define(
    "header-navigation",
    class HeaderNavigation extends HTMLElement {
      constructor() {
        super();

        this.header = document.querySelector(".header__container");
        this.headerContainer = this.querySelector('.header-v2--container')
        this.announcement = document.querySelector(
          ".header-announcement--container"
        );

        this.lastScrollY = window.scrollY;
        this.ticking = false;
        this.scrollThreshold = 5;

        this.headerHeight = 0;
        this.announcementHeight = 0;

        this.init();
      }

      init() {
        if (!this.header) return;

        this.measure();
        this.initMenu();
        this.handleScroll();
        this.bindScroll();
        this.observeResize();
        this.initBodyCss()

      }

      initBodyCss() {
        if (this.dataset.templateType !== "index") return;
        const MainContent = document.querySelector("#MainContent");
        MainContent.style.marginTop = `-${this.headerHeight - this.announcementHeight}px`
      }

      /* =========================
         菜单逻辑
      ========================= */
      initMenu() {
        const items = [...this.querySelectorAll(".header-menu-item")];

        items.forEach((item) => {
          const navs = [...item.querySelectorAll(".header-menu-item-left-nav")];
          const contents = [...item.querySelectorAll(".header-menu-item-content")];

          if (!navs.length) return;

          this.activateNav(navs, contents, 0);

          navs.forEach((nav, index) => {
            nav.addEventListener("mouseenter", () => {
              this.activateNav(navs, contents, index);
            });
          });
        });
      }

      activateNav(navs, contents, activeIndex) {
        navs.forEach((nav, i) => {
          nav.classList.toggle("active", i === activeIndex);
          contents[i]?.classList.toggle("active", i === activeIndex);
        });
      }

      /* =========================
         尺寸缓存
      ========================= */
      measure() {
        this.headerHeight = this.header.offsetHeight;
        this.announcementHeight = this.announcement
          ? this.announcement.offsetHeight
          : 0;
        this.initBodyCss()
      }

      observeResize() {
        new ResizeObserver(() => this.measure()).observe(this.header);
        if (this.announcement) {
          new ResizeObserver(() => this.measure()).observe(this.announcement);
        }
      }

      /* =========================
         Scroll 控制
      ========================= */
      bindScroll() {
        window.addEventListener("scroll", () => {
          if (!this.ticking) {
            requestAnimationFrame(() => {
              this.handleScroll();
              this.ticking = false;
            });
            this.ticking = true;
          }
        });
      }

      handleScroll() {
        const currentY = window.scrollY;
        const delta = currentY - this.lastScrollY;
        if (Math.abs(delta) < this.scrollThreshold) return;
        const isScrollDown = delta > 0;
        this.updateTransform(isScrollDown);
        this.lastScrollY = currentY;
        if (this.dataset.templateType == 'index') {
          this.headerContainer.classList[currentY > 20 ? 'remove' : 'add']('is--index')
        }
      }

      /* =========================
         核心 GPU 控制
      ========================= */
      updateTransform(isScrollDown) {
        // slide-navs 页面由 slide-navs 控制 header 显隐，这里不参与。
        // 在滚动时才读标志：header-navigation 的构造早于页面下方的 slide-navs，
        // 构造阶段判断不到。
        if (slideNavsOwnsHeaderTop) return;
        if (isScrollDown) {
          // 向下滚动
          if (this.dataset.templateType == "product") {
            this.header.style.top = `-${this.headerHeight}px`;
          } else {
            this.header.style.top = `-${this.announcementHeight}px`;
          }
        } else {
          // 向上滚动
          this.header.style.top = 0;
        }
      }
    }
  );

  customElements.define(
    "header-navigation-mobile",
    class headerNavigationMobile extends HTMLElement {
      constructor() {
        super();
        this.init();
        this.initControls();
      }
      init() {
        const menuMobiles = Array.from(this.querySelectorAll(".menu-mobile"));
        const menuSubMobile = Array.from(
          this.querySelectorAll(".menu-sub-mobile")
        );
        const menuSubMobileItems = Array.from(
          this.querySelectorAll(".menu-link-mobile-item")
        );
        this.menuMobiles = menuMobiles;
        this.selectItem(menuMobiles);
        this.selectItem(menuSubMobile);
        this.selectItem(menuSubMobileItems);
      }
      selectItem(list) {
        list.forEach((item) => {
          item.onclick = () => {
            $(item).toggleClass("active").next().slideToggle(300);
          };
        });
      }

      initControls() {
        if (window.theme) {
          new theme.CartDrawer();
        }
        document
          .querySelector("#header-menu-mobile-open")
          ?.addEventListener("click", () => {
            this.setAttribute("open", "");
          });
        this.querySelector(".header-navigation-mobile-close")?.addEventListener(
          "click",
          () => {
            this.removeAttribute("open");
          }
        );

        //predictive-search:close-all
        document.addEventListener("predictive-search:close-all", () => {
          document
            .querySelector(".site-header__search-container")
            .classList.remove("is-active");
        });

        const search_btn = document.querySelector("#header-menu-icon-search");
        search_btn?.addEventListener("click", function (evt) {
          evt.preventDefault();
          evt.stopPropagation();
          document.dispatchEvent(
            new CustomEvent("predictive-search:open", {
              detail: {
                context: "header",
              },
              bubbles: true,
            })
          );
          // add is-active class to .site-header__search-container
          document
            .querySelector(".site-header__search-container")
            .classList.add("is-active");
        });
      }
    }
  );

  customElements.define(
    "add-to-cart",
    class AddToCart extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const moneyFormat =
          theme.settings.moneyFormat[0] + "{{amount_no_decimals}}";
        const imageElement = this.querySelector(".add-to-cart-image") || {};
        const titleElement = this.querySelector(".add-to-cart-product-title");
        const tipElement = this.querySelector(".add-to-cart-product-tip")
        const textElement = this.querySelector(".add-to-cart-product-text");
        const priceElement = this.querySelector(".add-to-cart-price");
        const crossedPriceElement = this.querySelector(
          ".add-to-cart-crossed-price"
        );
        const discountAmountElement = this.querySelector(
          ".add-to-cart-discount-amount"
        );
        const addButton = this.querySelector(".add-to-cart-button");
        const addButtonText = this.querySelector(".add-to-cart-button-text");
        const discountContent = this.querySelector(
          ".add-to-cart-discount-content"
        );
        const variantEntriesJson = this.querySelector("#variant_entries_json");
        const variantEntries = JSON.parse(variantEntriesJson.innerText ?? "[]");
        const variantConfigJson = JSON.parse(this.querySelector("[data-variant-config-json]")?.value ?? '[]')

        document.addEventListener("product-variant-change", (event) => {
          const variant = event.detail.variant;
          const discount_amount = variant.compare_at_price - variant.price;
          imageElement.src = variant.featured_image && variant.featured_image.src || '';
          priceElement.innerText = theme.Currency.formatMoney(
            variant.price,
            theme.settings.moneyFormat
          );
          crossedPriceElement.innerText = theme.Currency.formatMoney(
            variant.compare_at_price,
            theme.settings.moneyFormat
          );
          discountAmountElement.innerText =
            "-" + theme.Currency.formatMoney(discount_amount, moneyFormat);
          discount_amount <= 0
            ? discountContent.classList.add("tw-hidden")
            : discountContent.classList.remove("tw-hidden");

          const variantTip = variantConfigJson.find(t => t.variant_id === variant.id)
          if (variantTip) {
            tipElement.innerText = variantTip.title
            $(tipElement).css({
              'background-color': variantTip.bg_color,
              'color': variantTip.title_color
            })
            tipElement.classList.remove('tw-hidden')
          } else {
            tipElement.classList.add('tw-hidden')
          }
        });

        document.addEventListener("update-fixed-cart-button", (event) => {
          if (!addButton) return;
          const variant = event.detail.variant;
          if (variant) {
            let entrieItem = variantEntries?.find(
              (t) => t.variant_id === variant.id
            );
            titleElement.innerText = entrieItem?.title ?? variant.options?.[0];
            textElement.innerText = entrieItem?.title
              ? ""
              : variant.options?.slice(1)?.join(" / ");
            if (variant.available) {
              // Available, enable the submit button and change text
              addButton.disabled = false;
              addButtonText.innerText = addButton.dataset.defaultText;
            } else {
              // Sold out, disable the submit button and change text
              addButton.disabled = true;
              addButtonText.innerText = theme.strings.soldOut;
            }
          } else {
            // The variant doesn't exist, disable submit button
            addButton.disabled = true;
            addButtonText.innerText = theme.strings.unavailable;
          }
        });

        const productAddToCart = document.querySelector("[data-add-to-cart]");
        addButton.addEventListener("click", () => {
          productAddToCart?.click();
        });

        const _this = this;
        const observerEvent = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              _this.removeAttribute("open");
            } else {
              _this.setAttribute("open", "");
            }
          });
        });

        productAddToCart && observerEvent.observe(productAddToCart);
      }

      updateTitle() { }
    }
  );
  customElements.define(
    "section-home-power",
    class SectionHomePower extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const items = this.querySelectorAll(".section-home-power-item");
        $(items).hover(
          function () {
            $(items).not(this).removeClass("active");
            this.classList.add("active");
          },
          function () {
            // console.log('移出')
          }
        );
      }
    }
  );

  customElements.define(
    "home-with",
    class HomeWith extends HTMLElement {
      constructor() {
        super();

        this.init();
      }

      init() {
        const swiperContainer = this.querySelector("swiper-component");
        const swiper = swiperContainer.swiper;
        if (this.getWinClientWidth() >= 768) {
          swiper.allowTouchMove = false;
        } else {
          swiper.allowTouchMove = true;
        }
        let nextTransForm = "";
        /** nextSpeed 移开鼠标后位移的时间 **/
        let nextSpeed = 0;
        /** 监听鼠标移到轮播图的子元素上，停止元素 **/

        let slideWidth = this.querySelector(".swiper-slide");
        swiper.el.onmouseover = function () {
          swiper.autoplay.stop();
          /** 保存下一次移动的位置 **/
          nextTransForm =
            "transform:" +
            $(swiperContainer)
              .find(".swiper-wrapper")
              .eq(0)
              .attr("style")
              .split("transform:")[1]
              .split(";")[0];
          let nextS =
            -1 *
            parseInt(
              nextTransForm.split("translate3d(")[1].split("px")[0]
            ); /** 得到当前鼠标下子元素上的距离左边的 **/
          let nowS =
            -1 *
            parseInt(
              $(swiperContainer)
                .find(".swiper-wrapper")
                .eq(0)
                .css("transform")
                .split("1, ")[2]
                .split(",")[0]
            );
          /** 得到实际上，鼠标移动后，子元素应该移动的时间 **/
          nextSpeed = 5000 * ((nextS - nowS) / $(slideWidth).width());
          /** transform---设置当前位置；前面的代码是兼容swiper2.0，因为2.0会加点料 **/ /** transition-duration:0ms;让元素不移动 **/
          $(swiperContainer)
            .find(".swiper-wrapper")
            .eq(0)
            .attr(
              "style",
              `${$(swiperContainer)
                .find(".swiper-wrapper")
                .eq(0)
                .attr("style")
                .split("transform: ")[0]
              }transform: ${$(swiperContainer)
                .find(".swiper-wrapper")
                .eq(0)
                .css("transform")};transition-duration:0ms;`
            );
        };
        swiper.el.onmouseout = function () {
          swiper.autoplay.start();
          $(swiperContainer)
            .find(".swiper-wrapper")
            .eq(0)
            .attr(
              "style",
              `${$(swiperContainer)
                .find(".swiper-wrapper")
                .eq(0)
                .attr("style")
                .split("transform: ")[0]
              }${nextTransForm};transition-duration:${nextSpeed}ms;`
            );
        };
      }
      getWinClientWidth() {
        return (
          document.documentElement.clientWidth || document.body.clientWidth
        );
      }
    }
  );
  customElements.define(
    "section-popup",
    class SectionPopup extends GlobalHTMLElement {
      constructor() {
        super();
        this.show_delay = Number(this.dataset.showDelay ?? 5000); // 首次进入页面五秒后弹出
        this.cool_down_days = Number(this.dataset.coolDownDays ?? 3); // 关闭后 3 天内不再显示
        this.campaign_version = "popup_" + this.dataset.campaignVersion;
        this.initPopupEvent();
        this.initPopup();
        this.listenerClose();
      }
      initPopup() {
        // 提交成功后的直接弹窗
        if (this.checkSuccess()) {
          const popup_items = this.querySelectorAll(".section-popup--item");
          popup_items[0].classList.add("active");
          popup_items[1].classList.remove("active");
          this.showPopup();
          return;
        }
        // 检测版本
        if (this.checkCampaignVersion()) return this.initOnePopup();
        if (this.isInCoolDown()) return;
        const status = this.getStatus();
        if (status.floatVisible) {
          // 用户曾经关闭弹窗但未彻底关闭 -> 显示浮动按钮
          this.setAttribute("show", "");
        } else {
          this.initOnePopup();
        }
      }

      checkSuccess() {
        const form_id = this.dataset.formId;
        const { hash, search } = window.location;
        return (
          search.includes("customer_posted=true") && hash.includes(form_id)
        );
      }

      initOnePopup() {
        switch (this.dataset.popupType) {
          case "delay":
            // 用户第一次访问 -> 5秒后弹出
            this.delayPopup();
            break;
          default:
            // 第一次访问滑动30%后弹出
            this.scrollPopup();
            break;
        }
      }
      delayPopup() {
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          this.showPopup();
          this.setAttribute("show", "");
        }, this.show_delay);
      }
      initPopupEvent() {
        this.close_btn = this.querySelector(".section-popup-close");
        const open_btn = this.querySelector(".section-popup-open");
        const sidebar_close_btn = this.querySelector(
          ".section-popup-sidebar-close"
        );
        open_btn.onclick = () => {
          this.showPopup();
        };
        this.close_btn.onclick = () => {
          if (this.checkSuccess()) {
            history.replaceState(null, "", window.location.pathname);
            this.removePopup();
          } else {
            this.hidePopup();
          }
        };
        sidebar_close_btn.onclick = () => {
          this.removePopup();
        };
      }
      getStatus() {
        return JSON.parse(
          localStorage.getItem("popup_newsletter_status") || "{}"
        );
      }
      setStatus(data) {
        data.campaign_version = this.campaign_version;
        localStorage.setItem("popup_newsletter_status", JSON.stringify(data));
      }
      removePopup() {
        this.setStatus({ closedTime: Date.now(), floatVisible: false });
        this.remove();
      }
      hidePopup() {
        const status = this.getStatus();
        this.open = false;
        status.floatVisible = true; // 显示浮动按钮
        this.setStatus(status);
      }
      showPopup() {
        this.open = true;
      }
      isInCoolDown() {
        const status = this.getStatus();
        if (!status.closedTime) return false;
        return (
          Date.now() - status.closedTime <
          this.cool_down_days * 24 * 60 * 60 * 1000
        );
      }
      checkCampaignVersion() {
        const status = this.getStatus();
        if (status.campaign_version !== this.campaign_version) {
          // 版本不同 -> 重置状态
          localStorage.removeItem("popup_newsletter_status");
          return true;
        }
        return false;
      }
      listenerClose() {
        const popup_container = this.querySelector(".section-popup-container");
        popup_container.addEventListener("click", (e) => {
          if (
            this.open &&
            (e.target == popup_container ||
              e.target == this.querySelector(".section-popup-close"))
          ) {
            this.close_btn.click();
          }
        });
      }
      scrollPopup() {
        this.scrollHandler = () => {
          if (this.scroll_triggered || this.open) return;
          const scrollTop =
            window.scrollY || document.documentElement.scrollTop;
          const docHeight =
            document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercent = scrollTop / docHeight;
          if (scrollPercent >= 0.3) {
            // 滚动超过30%
            this.scroll_triggered = true;
            clearTimeout(this.time); // 清除5秒延时触发
            this.showPopup();
            this.setAttribute("show", "");
            window.removeEventListener("scroll", this.scrollHandler);
          }
        };
        window.addEventListener("scroll", this.scrollHandler);
      }
    }
  );

  customElements.define(
    "popup-newsletter-form",
    class PopupNewsletterForm extends HTMLElement {
      constructor() {
        super();
        this.listenerForm();
      }
      listenerForm() {
        this.querySelector("form").addEventListener("submit", (e) => {
          this.querySelector("[type='submit']").classList.add("button-loading");
        });
      }
    }
  );

  customElements.define(
    "country-select",
    class CountryItem extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const links = this.querySelectorAll(".country-item");
        links.forEach((link) => {
          link.onclick = () => {
            const url = new URL(link.dataset.href);
            url.search = location.search;
            // window.location.href = url.toString();
            window.open(url.toString(), "_blank")
          };
        });
      }
    }
  );

  customElements.define(
    "section-product-header",
    class SectionProductHeader extends HTMLElement {
      constructor() {
        super();
        this.initVariants();
        this.cacheElements();
        this.init();
      }
      cacheElements() {
        this.cache = {
          price: this.querySelector("#product-details-price"),
          discountPrice: this.querySelector("#product-details-discount-price"),
          sku: this.querySelector("[data-variant-sku]"),
        };
      }
      init() {
        this.querySelectorAll("[data-variant-input]").forEach((el) => {
          el.addEventListener("change", this.onSelectChange.bind(this));
        });
      }
      onSelectChange(el) {
        const variant = this.getVariantOption(el.target.dataset.variantId);
        if (!variant) return;
        this.updateSwiperImages(variant);
        this.updateMasterSelect(variant);
        this.updatePrice(variant);
        this.updateUnitPrice(variant);
        this.updateSKU(variant);
      }
      updateSKU(variant) {
        this.cache.sku.innerText = variant.sku;
      }
      updateUnitPrice() { }
      updatePrice(variant) {
        let discount_amount = variant.compare_at_price - variant.price;
        this.cache.price.innerText = theme.Currency.formatMoney(variant.price);
        if (discount_amount <= 0) {
          this.cache.discountPrice.classList.add("tw-hidden");
        } else {
          this.cache.discountPrice.innerText =
            theme.Currency.formatMoney(discount_amount);
        }
      }
      updateSwiperImages() { }
      updateMasterSelect() { }

      getVariantOption(variantId) {
        return this.variantJson.find((t) => t.id == variantId);
      }
      initVariants() {
        this.variantJson = JSON.parse(
          this.querySelector("[data-variant-json]").innerHTML ?? "[]"
        );
        this.currentVariantJson = JSON.parse(
          this.querySelector("[current-variant-json]") ?? "{}"
        );
      }
    }
  );

  customElements.define(
    "section-hems-mode",
    class SectionHemsMode extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const thumbsTopSwiper = this.querySelector(
          "#" + this.dataset.thumbsTopId
        )?.swiper;
        const thumbsBottomSwiper = this.querySelector(
          "#" + this.dataset.thumbsBottomId
        )?.swiper;
        this.slides = thumbsBottomSwiper.slides;

        thumbsTopSwiper.on("slideChange", (e) => {
          this.selectItem(e.activeIndex);
          thumbsBottomSwiper.slideTo(e.activeIndex);
        });
        thumbsBottomSwiper.on("slideChange", (e) => {
          thumbsTopSwiper.slideTo(e.activeIndex);
        });

        this.slides.forEach((item, index) => {
          item.onclick = () => {
            this.selectItem(index);
            thumbsTopSwiper.slideTo(index);
          };
        });
      }
      selectItem(index) {
        this.slides[index].classList.add("active");
        this.slides
          .filter((t) => t != this.slides[index])
          .forEach((t) => t.classList.remove("active"));
      }
    }
  );

  customElements.define(
    "scroll-animation",
    class ScrollAnimation extends HTMLElement {
      constructor() {
        super();
        this.delay = 300;
        this.init();
      }
      init() {
        const firstItem = this.querySelector(".scroll-animation-item");
        const images = firstItem.querySelectorAll("img");
        images.forEach((img) => {
          img.onload = () => {
            this.initContent();
          };
        });
      }
      initContent() {
        const firstItem = this.querySelector(".scroll-animation-item");
        const scrollAnimationContent = this.querySelector(
          ".scroll-animation-content"
        );
        const contentHeight =
          scrollAnimationContent.getBoundingClientRect().height;
        const sectionPaddingTop = parseFloat($(this).css("padding-top"));
        this.scrollAnimationItem = Array.from(
          this.querySelectorAll(".scroll-animation-item")
        ).slice(1);
        this.itemHeight = firstItem.getBoundingClientRect().height;

        scrollAnimationContent.style.top = `calc((100vh - ${contentHeight}px) / 2)`;
        this.style.height =
          contentHeight +
          this.scrollAnimationItem.length * this.delay +
          this.itemHeight * (this.scrollAnimationItem.length - 1) +
          sectionPaddingTop +
          100 +
          "px";

        this.renderScroll();
      }
      getWinClientWidth() {
        return (
          document.documentElement.clientWidth || document.body.clientWidth
        );
      }
      renderScroll() {
        const moduleTop = $(this).offset().top + this.delay;
        const animationMap = new Map();

        this.scrollAnimationItem.forEach((item, index) => {
          let scrollStart = moduleTop + this.itemHeight * index;
          let scrollEnd = moduleTop + this.itemHeight * (index + 1);
          // animationMap.set(item, this.getDomAnimation(scrollStart, scrollEnd));
          animationMap.set(item, { scrollStart, scrollEnd });
        });

        const animationArr = Array.from(animationMap);
        window.addEventListener("scroll", () => {
          const scrollY = window.scrollY;
          for (let [index, [dom, value]] of animationArr.entries()) {
            const { scrollStart, scrollEnd } = value;
            if (scrollStart < scrollY && scrollEnd > scrollY) {
              dom.classList.add("active");
            } else {
              if (index == animationArr.length - 1 && scrollY > scrollEnd) {
                dom.classList.add("active");
              } else {
                dom.classList.remove("active");
              }
            }
          }
        });
      }
      getDomAnimation(scrollStart, scrollEnd, propStart = 0, propEnd = 1) {
        const opacityAnimation = this.createAnimation(
          scrollStart,
          scrollEnd,
          propStart,
          propEnd
        );
        const opacity = function (scroll) {
          return opacityAnimation(scroll);
        };
        return {
          opacity,
        };
      }
      createAnimation(scrollStart, scrollEnd, valueStart, valueEnd) {
        return function (scroll) {
          if (scroll <= scrollStart) {
            return valueStart;
          }
          if (scroll >= scrollEnd) {
            return valueEnd;
          }

          return (
            ((scroll - scrollStart) / (scrollEnd - scrollStart)) *
            (valueEnd - valueStart) +
            valueStart
          );
        };
      }
    }
  );
  customElements.define(
    "scroll-animation-img-video",
    class ScrollAnimationImgVideo extends HTMLElement {
      constructor() {
        super();
        this.delay = 300;
        this.init();
      }
      init() {
        const firstItem = this.querySelector(".scroll-animation-item");
        const images = firstItem.querySelectorAll("img");
        images.forEach((img) => {
          img.onload = () => {
            this.initContent();
          };
        });
      }
      initContent() {
        const firstItem = this.querySelector(".scroll-animation-item");
        const scrollAnimationContent = this.querySelector(
          ".scroll-animation-content"
        );
        const contentHeight =
          scrollAnimationContent.getBoundingClientRect().height;
        const sectionPaddingTop = parseFloat($(this).css("padding-top"));
        this.scrollAnimationItem = Array.from(
          this.querySelectorAll(".scroll-animation-item")
        ).slice(1);
        this.itemHeight = firstItem.getBoundingClientRect().height;

        scrollAnimationContent.style.top = `calc((100vh - ${contentHeight}px) / 2)`;
        this.style.height =
          contentHeight +
          this.scrollAnimationItem.length * this.delay +
          this.itemHeight * (this.scrollAnimationItem.length - 1) +
          sectionPaddingTop +
          100 +
          1000 + "px";

        this.renderScroll();
      }
      getWinClientWidth() {
        return (
          document.documentElement.clientWidth || document.body.clientWidth
        );
      }
      renderScroll() {
        const moduleTop = $(this).offset().top + this.delay;
        const animationMap = new Map();
        let additionalOffset = 0;
        this.scrollAnimationItem.forEach((item, index) => {
          let scrollStart =
            moduleTop + this.itemHeight * index + additionalOffset;
          let scrollEnd = scrollStart + this.itemHeight;
          // 对第一个元素特殊处理
          if (index == 0) {
            additionalOffset = 1000; // 为后续元素添加偏移量
            scrollEnd = scrollEnd + additionalOffset;
          }

          // 设置动画参数
          animationMap.set(item, {
            scrollStart,
            scrollEnd,
            ...(index == 0 && {
              transform: this.getDomAnimation(scrollStart, scrollEnd, 0.5, 1.3)
                .transform,
            }),
          });
        });

        const animationArr = Array.from(animationMap);
        // 使用节流函数优化滚动事件
        const throttle = (fn, delay) => {
          let lastCall = 0;
          return function (...args) {
            const now = new Date().getTime();
            if (now - lastCall < delay) return;
            lastCall = now;
            return fn(...args);
          };
        };

        // 添加动画过渡效果
        const handleScroll = () => {
          const scrollY = window.scrollY;
          for (let [index, [dom, value]] of animationArr.entries()) {
            const { scrollStart, scrollEnd, transform } = value;
            const isInViewport = scrollStart < scrollY && scrollEnd > scrollY;
            const isLastItem = index == animationArr.length - 1;
            const isPastLastItem = isLastItem && scrollY > scrollEnd;

            // 计算动画进度百分比
            if (isInViewport) {
              dom.classList.add("active");
              transform && (dom.style.transform = transform(scrollY));
            } else if (isPastLastItem) {
              dom.classList.add("active");
            } else {
              dom.classList.remove("active");
            }
          }
        };

        // // 添加CSS过渡效果
        // this.scrollAnimationItem.forEach((item) => {
        //   item.style.transition = "opacity 0.3s ease, transform 0.3s ease";
        // });

        window.addEventListener("scroll", throttle(handleScroll, 0)); // 约60fps

        // 初始触发一次滚动事件，确保初始状态正确
        handleScroll();
      }
      getDomAnimation(scrollStart, scrollEnd, propStart = 0, propEnd = 1) {
        const opacityAnimation = this.createAnimation(
          scrollStart,
          scrollEnd,
          propStart,
          propEnd
        );
        const opacity = function (scroll) {
          return opacityAnimation(scroll);
        };
        const transformAnimation = this.createAnimation(
          scrollStart,
          scrollEnd,
          propStart,
          propEnd
        );
        const transform = function (scroll) {
          return `scale(${transformAnimation(scroll)})`;
        };

        return {
          opacity,
          transform,
        };
      }
      createAnimation(scrollStart, scrollEnd, valueStart, valueEnd) {
        return function (scroll) {
          if (scroll <= scrollStart) {
            return valueStart;
          }
          if (scroll >= scrollEnd) {
            return valueEnd;
          }

          return (
            ((scroll - scrollStart) / (scrollEnd - scrollStart)) *
            (valueEnd - valueStart) +
            valueStart
          );
        };
      }
    }
  );

  customElements.define(
    "product-quantity",
    class SectionProductHeader extends GlobalHTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const minusButton = this.querySelector("[data-product-quantity-minus]");
        const plusButton = this.querySelector("[data-product-quantity-plus]");
        const input = this.querySelector("input[name='quantity']");
        minusButton.addEventListener("click", () => {
          let value = parseInt(input.value) || 1;
          if (value > 1) {
            input.value = value - 1;
            input.dispatchEvent(new Event("change", { bubbles: false }));
          }
        });
        plusButton.addEventListener("click", () => {
          let value = parseInt(input.value) || 0;
          if (value < 9999) {
            input.value = value + 1;
            input.dispatchEvent(new Event("change", { bubbles: false }));
          }
        });
        input.addEventListener("change", (e) => {
          let value = parseInt(e.target.value) || 1; // 默认值1
          if (value < 1) value = 1;
          if (value > 9999) value = 9999;
          e.target.value = value;
        });
      }
    }
  );

  customElements.define(
    "main-cart-drawer",
    class MainCartDrawer extends GlobalHTMLElement {
      constructor() {
        super();
        this.cache = {
          close_btn: this.querySelector("[data-cart-drawer-close]"),
          open_btn: document.querySelector("[data-cart-drawer-open]"),
          cart_total_price: this.querySelector("[data-cart-total-price]"),
          cart_total_discount: this.querySelector("[data-cart-total-discount]"),
          cart_total_discount_wrapper: this.querySelector(
            "[data-cart-total-discount-wrapper]"
          ),
          cart_drawer_footer: this.querySelector(
            "[data-main-cart-drawer-footer]"
          ),
          cart_bubble: document.querySelector(".cart-link__bubble"),
          cart_drawer_empty: this.querySelector("[data-cart-drawer-empty]"),
          cart_checkout_form: this.querySelector("#" + this.dataset.formId),
        };
        this.init();
        this.listenerKeydown();
      }
      init() {
        this.cache.close_btn.onclick = () => {
          this.closeDrawer();
        };
        this.cache.open_btn.onclick = () => {
          this.openDrawer();
        };
        document.addEventListener("main-cart:close", () => {
          this.closeDrawer();
        });
        document.addEventListener("main-cart:open", () => {
          this.openDrawer();
        });
        document.addEventListener("main-cart:render", () => {
          this.updateBubble(true);
          this.updateEmptyState(true);
          this.renderCartList();
        });
        document.addEventListener("main-cart:updated", (e) => {
          const { item_count } = e.detail.cart;
          this.updateBubble(item_count > 0);
          this.updateEmptyState(item_count > 0);
          this.renderCartList();
        });

        this.addEventListener("click", (e) => {
          if (
            this.open &&
            (e.target == this || e.target == this.cache.close_btn)
          ) {
            this.closeDrawer();
          }
        });
        this.cache.cart_checkout_form.onclick =
          ("click",
            () => {
              this.cache.cart_checkout_form.classList.add("button-loading");
            });
      }

      updateEmptyState(fl) {
        this.cache.cart_drawer_empty?.classList[fl ? "add" : "remove"](
          "tw-hidden"
        );
      }

      async renderCartList() {
        try {
          const parser = new DOMParser();
          const res = await fetch("/?sections=main-cart-drawer");
          const data = await res.json();
          const doc = parser.parseFromString(
            data["main-cart-drawer"] ?? "",
            "text/html"
          );
          const source = doc.querySelector(".main-cart-list");
          const cartItemEles = source.querySelectorAll(".main-cart-item");
          this.querySelector(".main-cart-list").replaceWith(source);
          const total_price = doc.querySelector("[data-cart-total-price")
            .dataset.price;
          const total_discount = doc.querySelector("[data-cart-total-discount]")
            .dataset.discountPrice;
          clearTimeout(this.time);
          this.time = setTimeout(() => {
            this.openDrawer();
            this.updateFooterPrice({
              item_count: cartItemEles.length ?? 0,
              total_price: Number(total_price ?? 0),
              total_discount: Number(total_discount ?? 0),
            });
            document.dispatchEvent(
              new CustomEvent("main-cart:recommendations", {
                detail: {
                  cartItemEles,
                },
                bubbles: true,
              })
            );
          }, 0);
        } catch (error) {
          console.error("error", error);
        }
      }

      updateFooterPrice({ total_price, total_discount, item_count }) {
        this.cache.cart_total_price.innerText = theme.Currency.formatMoney(
          total_price,
          theme.settings.moneyFormat
        );
        this.cache.cart_total_discount.innerText =
          "-" +
          theme.Currency.formatMoney(
            total_discount,
            theme.settings.moneyFormat
          );
        this.cache.cart_total_discount_wrapper.classList[
          total_discount ? "remove" : "add"
        ]("tw-hidden");
        this.cache.cart_drawer_footer.classList[
          item_count > 0 ? "remove" : "add"
        ]("tw-hidden");
      }

      updateBubble(fl) {
        this.cache.cart_bubble.classList[fl ? "add" : "remove"](
          "cart-link__bubble--visible"
        );
      }
      closeDrawer() {
        this.open = false;
        document.body.classList.remove("overflow-hidden");
      }
      openDrawer() {
        this.open = true;
        document.body.classList.add("overflow-hidden");
      }
    }
  );

  customElements.define(
    "main-cart-item",
    class MainCartItem extends HTMLElement {
      constructor() {
        super();
        this.init();
      }
      init() {
        const remove_btn = this.querySelector("[data-main-cart-item-remove]");
        this.quantity_input = this.querySelector("input[name='quantity']");
        this.defaultValue = parseInt(this.quantity_input.value) || 1;

        remove_btn.onclick = () => {
          this.updateQuantity(0);
        };
        this.quantity_input.addEventListener("change", (e) => {
          let value = parseInt(e.target.value) || 1; // 默认值1
          this.updateQuantity(value);
        });
      }

      updateQuantity(qty) {
        this.fetchUpdate(this.dataset.lineKey, qty);
      }

      fetchUpdate(lineKey, qty) {
        let updates = {
          [lineKey]: Number(qty),
        };
        this.updateLodading(true);
        fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates }),
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.message) {
              this.initValue();
              alert(data.message);
              return;
            }
            qty === 0 && this.remove();
            document.dispatchEvent(
              new CustomEvent("main-cart:updated", {
                detail: { cart: data },
                bubbles: true,
              })
            );
          })
          .catch((error) => {
            alert("error", error);
            this.initValue();
          })
          .finally(() => {
            this.updateLodading(false);
          });
      }
      initValue() {
        this.quantity_input.value = this.defaultValue;
      }

      updateLodading(fl) {
        fl
          ? this.classList.add("cart-loading")
          : this.classList.remove("cart-loading");
      }
    }
  );

  customElements.define(
    "product-bondage",
    class ProductBondage extends HTMLElement {
      connectedCallback() {
        this.url = this.dataset.url;
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        this.limit = this.dataset.limit;
        this.target = this.querySelector("[data-bondage-target]");

        // variant 下拉切换时更新价格显示
        this.addEventListener("change", (e) => {
          if (e.target.matches("[data-bondage-variant]")) {
            this._syncPrice(e.target);
          }
        });

        this._loadRecommendations();
      }

      // 异步请求产品推荐（互补产品 intent=complementary），填入捕绑区
      _loadRecommendations() {
        if (!this.productId || !this.target) return;
        fetch(
          `${this.url}?section_id=${this.sectionId}&product_id=${this.productId}&limit=${this.limit}&intent=complementary`
        )
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, "text/html");
            const block = doc.querySelector(".js-bondage-recommendations");
            // 用实际渲染的卡片数判断（data-count 是原始推荐数，可能被 available 过滤掉）
            const hasProducts = block && block.querySelectorAll(".product-bondage__item").length > 0;
            if (hasProducts) {
              this.target.innerHTML = block.innerHTML;
              this.classList.remove("tw-hidden");
            } else {
              this.target.innerHTML = "";
              this.classList.add("tw-hidden");
            }
          })
          .catch((error) => {
            console.error("product-bondage error", error);
            this.classList.add("tw-hidden");
          });
      }
      // variant 下拉切换时更新价格显示
      _syncPrice(select) {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        const item = select.closest(".product-bondage__item");
        const priceEl = item?.querySelector(".product-bondage__price");
        if (!priceEl) return;
        const price = option.dataset.price;
        const compare = option.dataset.compare;
        if (compare) {
          priceEl.innerHTML =
            `<span class="product-bondage__price-sale">${price}</span>` +
            `<span class="product-bondage__price-compare">${compare}</span>`;
        } else {
          priceEl.innerHTML = `<span class="product-bondage__price-regular">${price}</span>`;
        }
      }
    }
  );

  // 弹窗内 variant 选择同步回卡片 select（影响加购）
  customElements.define(
    "bondage-modal-variant",
    class BondageModalVariant extends HTMLElement {
      connectedCallback() {
        this.select = this.querySelector("select");
        this.targetId = this.dataset.syncTarget;
        if (!this.select) return;
        this.select.addEventListener("change", () => {
          const target = document.getElementById(this.targetId);
          if (!target) return;
          target.value = this.select.value;
          // 触发卡片 select 的 change，联动价格显示
          target.dispatchEvent(new Event("change", { bubbles: true }));
        });
      }
    }
  );

  // 捆绑标签页版：仅负责感叹号 tooltip（标签切换交给内部 swiper-component）
  customElements.define(
    "bundle-tabs",
    class BundleTabs extends HTMLElement {
      connectedCallback() {
        // 捕获阶段拦截感叹号点击，阻止冒泡到 .swiper-tab-item 触发切页
        this.addEventListener(
          "click",
          (e) => {
            const info = e.target.closest(".bundle-tabs__info");
            if (!info) return;
            e.stopPropagation();
            e.preventDefault();
            const open = info.classList.contains("is-open");
            this.querySelectorAll(".bundle-tabs__info.is-open").forEach((el) =>
              el.classList.remove("is-open")
            );
            if (!open) info.classList.add("is-open");
          },
          true
        );

        // 点击外部关闭 tooltip
        document.addEventListener("click", (e) => {
          if (!this.contains(e.target)) {
            this.querySelectorAll(".bundle-tabs__info.is-open").forEach((el) =>
              el.classList.remove("is-open")
            );
          }
        });

        // 变体下拉切换：更新价格显示 + 加购用的 variant id
        this.addEventListener("change", (e) => {
          if (e.target.matches("[data-bondage-variant]")) {
            this._syncVariant(e.target);
          }
        });

        // 数量选择器 +/- 步进
        this.addEventListener("click", (e) => {
          const minus = e.target.closest("[data-bondage-qty-minus]");
          const plus = e.target.closest("[data-bondage-qty-plus]");
          if (!minus && !plus) return;
          e.preventDefault();
          const wrap = e.target.closest("[data-bondage-qty-wrap]");
          const input = wrap && wrap.querySelector("[data-bondage-qty]");
          if (!input) return;
          let val = parseInt(input.value, 10) || 1;
          val = plus ? val + 1 : Math.max(1, val - 1);
          input.value = val;
        });
      }

      _syncVariant(select) {
        const option = select.options[select.selectedIndex];
        if (!option) return;
        const item = select.closest(".product-bondage__item");
        if (!item) return;
        // 同步加购用的变体 id
        const checkbox = item.querySelector("[data-bondage-checkbox]");
        if (checkbox) checkbox.dataset.variantId = select.value;
        // 更新价格显示（option 的 data-price/data-compare 已是 money 格式）
        const priceEl = item.querySelector(".product-bondage__price");
        if (!priceEl) return;
        const price = option.dataset.price;
        const compare = option.dataset.compare;
        if (compare) {
          priceEl.innerHTML =
            `<span class="product-bondage__price-sale">${price}</span>` +
            `<span class="product-bondage__price-compare">${compare}</span>`;
        } else {
          priceEl.innerHTML = `<span class="product-bondage__price-regular">${price}</span>`;
        }
      }
    }
  );

  customElements.define(
    "cart-recommendations",
    class CartRecommendations extends HTMLElement {
      constructor() {
        super();
        this.el = this;
        this.url = this.dataset.url;
        this.intent = this.dataset.intent;
        this.section_id = this.dataset.sectionId;
        this.product_id = this.dataset.productId;
        this.limit = this.dataset.limit;
        this.init();
        this.listenerCartAdd();
      }
      init() {
        this.updateRecommendationState(this.product_id);
        this.renderRecommendationProducts(this.product_id);
      }
      listenerCartAdd() {
        document.addEventListener("main-cart:recommendations", (e) => {
          // const product_id = event.detail.product_id
          const { cartItemEles } = e.detail;
          const product_id = cartItemEles?.[0]?.dataset.productId;
          if (this.product_id == product_id) return;
          this.product_id = product_id;
          this.renderRecommendationProducts(product_id);
          this.updateRecommendationState(product_id);
        });
      }

      updateRecommendationState(product_id) {
        this.classList[product_id ? "remove" : "add"]("tw-hidden");
      }

      renderRecommendationProducts(product_id) {
        if (!product_id) return;
        this.classList.add("cart-loading");
        fetch(
          `${this.url}?section_id=${this.section_id}&product_id=${product_id}&limit=${this.limit}&intent=complementary`
        )
          .then((response) => response.text())
          .then((text) => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, "text/html");
            const cartItems = Array.from(
              document.querySelectorAll(".main-cart-item")
            );
            const recommendationEl = doc.querySelector("cart-recommendations");
            recommendationEl
              ?.querySelectorAll(".swiper-slide")
              .forEach((item) => {
                if (
                  cartItems.find(
                    (t) => t.dataset.variantId == item.dataset.variantId
                  )
                ) {
                  item.remove();
                }
              });
            // 过滤后无推荐商品则隐藏整个区块（含标题）
            const remaining = recommendationEl?.querySelectorAll(".swiper-slide").length || 0;
            if (remaining === 0) {
              this.classList.add("tw-hidden");
              this.innerHTML = "";
              return;
            }
            this.classList.remove("tw-hidden");
            this.innerHTML = recommendationEl.innerHTML;
          })
          .catch((error) => {
            console.error("error", error);
          })
          .finally(() => {
            this.classList.remove("cart-loading");
          });
      }
    }
  );

  // 搜索下拉默认推荐：基于购物车首商品，异步请求 Product Recommendations Section API
  customElements.define(
    "predictive-recommendations",
    class PredictiveRecommendations extends HTMLElement {
      constructor() {
        super();
        this.url = this.dataset.url;
        this.sectionId = this.dataset.sectionId;
        this.productId = this.dataset.productId;
        this.limit = this.dataset.limit;
        this.target = this.querySelector(".predictive-recommendations-target");
        this.init();
        this.listenCartChange();
      }

      init() {
        this.render(this.productId);
      }

      // 购物车变化时更新基准商品（与 cart-recommendations 复用同一事件）
      listenCartChange() {
        document.addEventListener("main-cart:recommendations", (e) => {
          const { cartItemEles } = e.detail || {};
          const productId = cartItemEles?.[0]?.dataset.productId;
          if (this.productId == productId) return;
          this.productId = productId;
          this.render(productId);
        });
      }

      render(productId) {
        // 购物车为空 / 无基准商品：隐藏整个推荐区
        if (!productId) {
          this.classList.add("tw-hidden");
          if (this.target) this.target.innerHTML = "";
          return;
        }
        fetch(
          `${this.url}?section_id=${this.sectionId}&product_id=${productId}&limit=${this.limit}`
        )
          .then((response) => response.text())
          .then((text) => {
            const doc = new DOMParser().parseFromString(text, "text/html");
            const block = doc.querySelector(".js-predictive-recommendations");
            const hasProducts = block && parseInt(block.dataset.count, 10) > 0;
            if (hasProducts) {
              this.target.innerHTML = block.innerHTML;
              this.classList.remove("tw-hidden");
            } else {
              this.target.innerHTML = "";
              this.classList.add("tw-hidden");
            }
          })
          .catch((error) => {
            console.error("predictive-recommendations error", error);
            this.classList.add("tw-hidden");
          });
      }
    }
  );

  customElements.define(
    "cart-discount",
    class CartDiscount extends HTMLElement {
      constructor() {
        super();

        // 节点缓存
        this.discount_application = this.querySelector(
          ".cart-discount__application"
        );
        this.discount_application_item_template = this.querySelector(
          "#cart-discount__application_item-template"
        );
        this.discount_input = this.querySelector(".cart-discount__input");
        this.discount_apply = this.querySelector(".cart-discount__apply");
        this.discount_toggle = this.querySelector(".cart-discount__toggle");
        this.discount_form = this.querySelector(".cart-discount__form");

        // 当前已应用的折扣码（取自服务端渲染的标签）
        this.discount_codes = Array.from(
          this.querySelectorAll(".cart-discount__application_title")
        ).map((t) => t.innerText.trim());

        this.init();
      }

      /** 初始化事件 */
      init() {
        this.discount_toggle?.addEventListener("click", () => {
          this.discount_toggle.classList.toggle("active");
          $(this.discount_form).slideToggle(200);
        });

        this.discount_form.addEventListener("submit", (event) => {
          event.preventDefault();
          this.handleApplyDiscount();
        });

        // 使用事件委托，减少重复绑定
        this.discount_application?.addEventListener("click", (e) => {
          const closeBtn = e.target.closest(
            ".cart-discount__application_close"
          );
          if (!closeBtn) return;
          const code = closeBtn.dataset.code;
          this.handleRemoveDiscount(code);
        });
      }

      /** 应用折扣码 */
      async handleApplyDiscount() {
        const code = this.discount_input?.value?.trim();
        if (!code) return;
        this.discount_apply.classList.add("button-loading");
        try {
          // update.js 的 discount 是整体替换，所以要带上已有的码
          const codes = [...new Set([...this.discount_codes, code])];
          const cart = await this.updateDiscountCodes(codes);
          const applied = this.getAppliedCodes(cart);
          // 购物车里没出现这个码 = 无效或不满足条件
          const ok = applied.some((c) => c.toLowerCase() === code.toLowerCase());
          if (ok) {
            this.updateDiscountApplication(applied);
            document.dispatchEvent(
              new CustomEvent("main-cart:render", { bubbles: true })
            );
          }
          this.discount_form.classList[ok ? "remove" : "add"]("error");
        } catch (err) {
          console.error("applyDiscount error:", err);
          this.discount_form.classList.add("error");
        } finally {
          this.discount_apply.classList.remove("button-loading");
        }
      }

      /** 移除折扣码 */
      async handleRemoveDiscount(code) {
        try {
          this.classList.add("cart-loading");
          // 去掉目标码后整体回写；全部移除时传空串
          const codes = this.discount_codes.filter((c) => c !== code);
          const cart = await this.updateDiscountCodes(codes);
          this.updateDiscountApplication(this.getAppliedCodes(cart));
          document.dispatchEvent(
            new CustomEvent("main-cart:render", { bubbles: true })
          );
        } catch (err) {
          console.error("removeDiscount error:", err);
        } finally {
          this.classList.remove("cart-loading");
        }
      }

      /** 更新折扣码标签 UI */
      updateDiscountApplication(codes) {
        this.discount_application.innerHTML = ""; // 清空再重建
        const fragment = document.createDocumentFragment();

        codes.forEach((code) => {
          const tpl =
            this.discount_application_item_template.content.cloneNode(true);
          const title = tpl.querySelector(".cart-discount__application_title");
          const close = tpl.querySelector(".cart-discount__application_close");

          title.innerText = code;
          close.dataset.code = code;
          fragment.appendChild(tpl);
        });

        this.discount_codes = codes;
        this.discount_application.appendChild(fragment);
      }

      /**
       * 通过 Ajax Cart API 设置折扣码（POST cart/update.js）。
       * discount 是逗号分隔的字符串，会整体替换购物车上的折扣码；空串表示全部移除。
       * 参考：https://shopify.dev/docs/api/ajax/reference/cart
       */
      async updateDiscountCodes(codes) {
        const response = await fetch(
          `${window.Shopify.routes.root}cart/update.js`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify({ discount: codes.join(",") }),
          }
        );
        if (!response.ok) {
          throw new Error(`cart/update.js ${response.status}`);
        }
        return response.json();
      }

      /**
       * 从购物车数据里取出实际生效的折扣码。
       * cart/update.js 返回的 discount_codes 项形如 { code, amount, type }，
       * 没有 applicable 字段 —— 能出现在里面就说明已生效，所以只排掉显式
       * applicable: false 的情况（Storefront 风格返回会带这个标记）。
       * 没有 discount_codes 时回退到折扣应用列表，与 snippet 里服务端渲染
       * cart.discount_applications 的判断一致。
       */
      getAppliedCodes(cart) {
        if (!cart) return [];
        if (Array.isArray(cart.discount_codes)) {
          return cart.discount_codes
            .filter((d) => d.applicable !== false)
            .map((d) => d.code);
        }
        const fromApps = (cart.cart_level_discount_applications || [])
          .filter((a) => a.type === "discount_code")
          .map((a) => a.title);
        const fromLines = (cart.items || []).flatMap((item) =>
          (item.line_level_discount_allocations || [])
            .map((d) => d.discount_application)
            .filter((a) => a && a.type === "discount_code")
            .map((a) => a.title)
        );
        return [...new Set([...fromApps, ...fromLines])];
      }
    }
  );

  customElements.define(
    "count-down",
    class CountDown extends HTMLElement {
      connectedCallback() {
        CountDown.loadDayjs()
          .then(() => this.whenChildrenParsed())
          .then(() => this.init())
          .catch((err) => {
            console.error("⛔ CountDown:", (err && err.message) || err);
          });
      }

      disconnectedCallback() {
        this.stop();
      }

      // parser 创建的元素在 connectedCallback 时子节点可能还没解析完
      whenChildrenParsed() {
        if (document.readyState !== "loading") return Promise.resolve();
        return new Promise((resolve) =>
          document.addEventListener("DOMContentLoaded", resolve, { once: true })
        );
      }

      init() {
        const {
          numberClass,
          downEndTime,
          timeZones = "Europe/Berlin",
        } = this.dataset;

        if (!downEndTime) {
          console.error("⛔ CountDown 缺少 downEndTime！");
          return;
        }
        this.timeDoms = this.querySelectorAll(`.${numberClass}`);
        this.timeZones = timeZones;
        this.downEndTime = downEndTime;

        this.setTargetTime();
        this.start();
      }

      // 设置目标结束时间戳
      setTargetTime() {
        this.setTime = this.getTargetTime(this.downEndTime).valueOf();
        console.log(
          "⏳ CountDown 目标时间:",
          this.setTime,
          "当前时区:",
          this.timeZones
        );
      }

      // 启动倒计时
      start() {
        this.stop();
        this.intervalTime = setInterval(this.updateCountdown.bind(this), 1000);
        this.updateCountdown(); // 立即执行一次，避免初始延迟
      }

      // 停止倒计时
      stop() {
        if (this.intervalTime) {
          clearInterval(this.intervalTime);
          this.intervalTime = null;
        }
      }

      // 当前时区时间
      getCurrentTime() {
        return dayjs().tz(this.timeZones);
      }

      // 获取指定时区时间（带容错）
      getTargetTime(time) {
        if (!time) return this.getCurrentTime();

        let parsed = dayjs.tz(time, this.timeZones);

        // 容错：支持 YYYY/MM/DD 格式
        if (!parsed.isValid()) {
          parsed = dayjs.tz(time.replace(/-/g, "/"), this.timeZones);
        }

        if (!parsed.isValid()) {
          console.error("⛔ Invalid time:", time);
          return this.getCurrentTime();
        }

        return parsed;
      }

      // 倒计时逻辑
      updateCountdown() {
        const now = this.getCurrentTime().valueOf();
        let remainingSeconds = Math.floor((this.setTime - now) / 1000);
        // 倒计时结束
        if (remainingSeconds <= 0) {
          this.stop();
          if (document.getElementById(`coupon-${this.dataset.removeId}`)) {
            document.getElementById(`coupon-${this.dataset.removeId}`).remove();
          }
          return;
        }

        // 转换为 d/h/m/s
        const d = Math.floor(remainingSeconds / 86400);
        const h = Math.floor((remainingSeconds / 3600) % 24);
        const m = Math.floor((remainingSeconds / 60) % 60);
        const s = Math.floor(remainingSeconds % 60);

        // 渲染到页面
        if (this.timeDoms?.length) {
          const values = [d, h, m, s].map((v) => String(v).padStart(2, "0"));
          this.timeDoms.forEach((dom, i) => (dom.innerText = values[i]));
        }
      }

      // 全页面共享一次加载：多个 <count-down> 不会重复插入脚本，
      // 也不会在脚本还没执行完时就去读 window.dayjs
      static loadDayjs() {
        if (CountDown.dayjsReady) return CountDown.dayjsReady;

        // 必须走同源 asset：consentmanager 的 autoblocking 会把跨域
        // <script> 的 src 挪到 data-cmp-src 并清空 src，导致 onerror。
        // 同源 /cdn/shop/t/*/assets/ 不会被改写。
        const scriptSrcs = [
          ASSET_BASE + "day.min.js",
          ASSET_BASE + "utc.min.js",
          ASSET_BASE + "timezone.min.js",
        ];

        const loadScript = (src) =>
          new Promise((resolve, reject) => {
            const script = document.createElement("script");
            script.src = src;
            script.async = false;
            script.onload = resolve;
            // onerror 只给一个 Event，自己带上 src 才能定位是哪个文件挂了
            script.onerror = () => reject(new Error(`脚本加载失败: ${src}`));
            document.head.appendChild(script);
          });

        CountDown.dayjsReady = scriptSrcs
          .reduce(
            (chain, src) => chain.then(() => loadScript(src)),
            Promise.resolve()
          )
          .then(() => {
            if (!window.dayjs) throw new Error("dayjs 未挂到 window 上");
            dayjs.extend(window.dayjs_plugin_utc);
            dayjs.extend(window.dayjs_plugin_timezone);
          })
          .catch((err) => {
            // 失败后清掉缓存，下一个实例（或重新渲染）还能重试
            CountDown.dayjsReady = null;
            throw err;
          });

        return CountDown.dayjsReady;
      }
    }
  );
  customElements.define(
    "scroll-image-canvas",
    class ScrollImageCanvas extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector("#scroll--content");
        this.canvas = this.querySelector("#scroll--canvas");
        this.ctx = this.canvas.getContext("2d");
        this.placeholderImage = this.querySelector("#scroll--image")
        this.frameCount = 39;
        this.frameGap = this.dataset.frameGap || 80;
        this.frameGapMd = this.dataset.frameGapMd || 30;
        this.gap = 0;
        this.init();
        this.getImages()
      }
      init() {
        this.placeholderImage.onload = () => {
          this.content.style.top = `calc((100vh - ${this.content.clientHeight}px) / 2)`;
          this.scrollSection();
        }
        window.addEventListener("resize", debounce(() => {
          this.linearSize();
          this.content.style.top = `calc((100vh - ${this.content.clientHeight}px) / 2)`;
          this.scrollSection();
        }, 200));
        this.linearSize();
      }

      linearSize() {
        const viewportWidth = this.getWinClientWidth();
        viewportWidth <= 768 ? this.gap = this.frameGapMd : this.gap = this.frameGap
      }

      getImages() {
        // 预加载
        let loaded = 0;
        this.images = [];
        for (let i = 0; i < this.frameCount; i++) {
          const img = new Image();
          img.src = this.framePath(i);
          img.onload = () => {
            loaded++;
            if (loaded === this.frameCount) {
              this.content.classList.remove("loading");
              this.drawCanvas(0);
            };
            this.images[i] = img;
          }
        }
      }

      drawCanvas(index) {
        console.log("index", index)
        const img = this.images[index];
        if (!img) return;
        this.canvas.width = img.width;
        this.canvas.height = img.height;
        this.ctx.drawImage(img, 0, 0);

        this.placeholderImage.classList[index > 16 ? "remove" : "add"]("tw-opacity-0");
      }

      scrollSection() {
        const viewportHeight = this.getViewportHeight();
        const scrollContentTop = (viewportHeight - this.content.clientHeight) / 2;
        const totalScroll = this.gap * this.frameCount + this.content.clientHeight + scrollContentTop;
        this.style.height = totalScroll + 'px'

        window.addEventListener("scroll", () => {
          const scrollTop = this.getScrollTop();
          const sectionTop = this.offsetTop;
          const sectionHeight = this.offsetHeight;
          if ((sectionTop - scrollContentTop) < scrollTop && (sectionTop + sectionHeight - scrollContentTop) > scrollTop) {
            const scrollY = scrollTop - sectionTop;
            let index = Math.min(
              this.frameCount - 1,
              Math.floor(scrollY / this.gap)
            );
            index = Math.max(0, index);
            this.drawCanvas(index);
          }
        });

      }
      // https://cdn.shopify.com/s/files/1/0550/5312/3661/files/new_800plus_010.png?v=1764406949
      framePath(index) {
        return `https://cdn.shopify.com/s/files/1/0550/5312/3661/files/new_800plus_${String(index).padStart(3, '0')}.png?width=1920&v=1764407110969`;
      }

      getViewportHeight() {
        return window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight ||
          0;
      }

      getWinClientWidth() {
        return (
          document.documentElement.clientWidth || document.body.clientWidth
        );
      }

      getScrollTop() {
        return window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
      }

    }
  );
  customElements.define("faq-conetnt-v2", class FAQConetntV2 extends HTMLElement {
    constructor() {
      super();
      this.init();
    }
    init() {
      const tabs = Array.from(this.querySelectorAll(".section-faq-v2-tab"));
      const tabBlocks = Array.from(this.querySelectorAll(".section-faq-v2-tab-block"));
      const itemTitles = Array.from(this.querySelectorAll(".section-faq-v2-item-title"));
      const tabTitles = Array.from(this.querySelectorAll(".section-faq-v2-tab-title"));
      const tabContainer = this.querySelector(".section-faq-v2-tab-container");
      const faqContent = this.querySelector(".section-faq-v2-content");

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          tabs.filter(t => t != tab).forEach(t => t.classList.remove("active"));
          tab.classList.add("active");
          const target = tabBlocks[index];
          tabBlocks.filter(t => t != target).forEach(t => t.classList.remove("active"));
          target.classList.add("active");
          tabContainer.classList.remove("active")
          faqContent.classList.add("active");
        });
      });

      itemTitles.forEach(titleElement => {
        titleElement.addEventListener("click", () => {
          const content = titleElement.nextElementSibling;
          titleElement.classList.toggle("active");
          $(content).slideToggle(300);
        });
      });
      tabTitles.forEach(titleElement => {
        titleElement.addEventListener("click", () => {
          if (this.getWinClientWidth() > 768) return;
          tabBlocks.forEach(t => t.classList.remove("active"));
          tabContainer.classList.add("active");
          faqContent.classList.remove("active");
        })
      })
    }
    getWinClientWidth() {
      return (
        document.documentElement.clientWidth || document.body.clientWidth
      );
    }

  })

  customElements.define("variant-fieldset", class VariantFieldset extends HTMLElement {
    constructor() {
      super()
      this.getVariants()
      this.init()
    }
    init() {
      const variantInputs = Array.from(document.querySelectorAll("[data-variant-input]"))
      this.variantInputCustoms = Array.from(this.querySelectorAll("[data-variant-input-custom]"));
      this.currentVariant = JSON.parse(document.querySelector("[data-current-variant-json]")?.innerHTML ?? '{}')
      this.variantOptions = variantInputs.map(input => {
        return {
          index: input.dataset.index,
          value: input.value,
          element: input
        }
      })

      this.selectInputCustoms(this.currentVariant.id)
      this.variantInputCustoms.forEach((input) => {
        input.addEventListener("click", () => {
          this.selectInputCustoms(input.value)
          this.selectOptions(input.value)
        })
      })

      document.addEventListener("update-fixed-cart-button", (event) => {
        this.selectInputCustoms(event.detail.variant.id)
      })
    }

    selectInputCustoms(variantId) {
      const currentInput = this.variantInputCustoms.find(inp => Number(inp.value) === Number(variantId))
      if (!currentInput) return
      currentInput.checked = true
      this.variantInputCustoms.filter(inp => inp != currentInput).forEach(t => t.checked = false)
    }

    selectOptions(variantId) {
      const variant = this.getVariant(variantId)
      variant.options.forEach((value, i) => {
        const option = this.getCurrentOption({
          index: `option${i + 1}`,
          value: value
        })
        option.element && !option.element.checked && option.element.click()
      })
    }

    getCurrentOption({ index, value }) {
      return this.variantOptions.find(t => t.index === index && t.value === value)
    }
    getVariant(variantId) {
      return this.variants.find(t => t.id === Number(variantId))
    }
    getVariants() {
      this.variants = JSON.parse(
        document.querySelector("[data-variant-json]").innerHTML ?? "[]"
      );
    }
  })

  customElements.define("rec-combo", class RecCombo extends HTMLElement {
    constructor() {
      super()
      this.init()
    }
    init() {
      const comboItems = Array.from(this.querySelectorAll(".section-rec-combo-item"));
      comboItems.forEach(item => {
        item.addEventListener("click", () => {
          const checkbox = item.querySelector("input[type='checkbox']");
          checkbox.checked = !checkbox.checked;
          item.classList[checkbox.checked ? "add" : "remove"]("active");
        })
      })


      const jsonData = [
        {
          title: '您的家庭是否需要安装光伏板?',
          type: '1',
          children: [
            {
              value: 100,
              label: "Yes"
            },
            {
              value: 0,
              label: "No"
            }
          ]
        },
        {
          title: '您想SolarFlow覆盖最高功率的用电器是?',
          type: '2',
          children: [
            {
              value: 800,
              label: "小于等于800W"
            },
            {
              value: 1600,
              label: "小于等于1600W"
            },
            {
              value: 2400,
              label: "小于等于2400W"
            },
            {
              value: 3200,
              label: "大于2400W",
              isTsl: true,
              description: '特斯拉'
            }
          ]
        },
        {
          title: '最适合您的能源解决方案就是它:',
          type: '3',
          children: [
            {
              value: 800,
              label: "SolarFlow1600 AC+",
            },
            {
              value: 2400,
              label: "SolarFlow2400 AC+"
            },
            {
              value: 2500,
              label: "SolarFlow2400 Pro"
            },
            {
              value: 3200,
              label: "SolarFlow多套系统"
            }
          ]
        }
      ]
    }
  })

  customElements.define('field-radio', class FieldRadio extends HTMLElement {
    constructor() {
      super()
      this.fieldRadios = this.querySelectorAll('.field--radio')
      this.radioInput = this.querySelector('input')
      this.init()
    }
    init() {
      const event = new Event('input-validate', { bubbles: true });
      this.fieldRadios.forEach(fieldRadio => {
        fieldRadio.addEventListener('click', () => {
          $(this.fieldRadios).not(fieldRadio).removeClass('active')
          fieldRadio.classList.add('active')
          this.radioInput.value = fieldRadio.dataset.value
          this.radioInput.dispatchEvent(event)
        })
      })
    }
  })

  customElements.define('field-checkbox', class FieldCheckbox extends HTMLElement {
    constructor() {
      super()
      this.fieldCheckboxList = this.querySelector('.field--checkbox-list')
      this.labelInput = this.querySelector('input')
      this.checkboxItems = Array.from(this.querySelectorAll('.field--checkbox-option'))
      this.init()
    }

    init() {
      this.checkboxItems?.forEach(t => {
        t.addEventListener("click", () => {
          t.classList.toggle('active')
          this.updateInputValue([{
            value: t.getAttribute('data-value'),
            label: t.getAttribute('data-label')
          }])
        })

      })
    }
    updateInputValue(data) {
      this.initValues = data || []
      this.labelInput.setAttribute("data-value", JSON.stringify(this.initValues))
      this.labelInput.value = data?.[0].value
      // flag是否需要触发input-validate
      // this.labelInput.dispatchEvent(new CustomEvent('input-validate', {
      //   bubbles: true,
      // }))
    }
  })

  customElements.define('auto-height', class AutoHeight extends HTMLElement {
    constructor() {
      super()
      this.options = this.dataset.options?.split(',') || []
      this.debouncedRecalc = this.debounce(() => this.init(), 200)
    }

    connectedCallback() {
      this.init()
      this.observeResize()
    }

    disconnectedCallback() {
      this.ro && this.ro.disconnect()
      window.removeEventListener('resize', this.debouncedRecalc)
    }

    // 核心逻辑
    init() {
      this.options.forEach(clsName => {
        const items = Array.from(this.querySelectorAll('.' + clsName))
        if (!items.length) return

        // 先清空高度，避免越算越高
        items.forEach(t => (t.style.height = 'auto'))

        const images = items
          .map(t => t.querySelector('img'))
          .filter(Boolean)

        if (!images.length) {
          this.setItemHeight(items)
          return
        }

        const waitImages = images.map(img => {
          return new Promise(resolve => {
            if (img.complete && img.naturalWidth !== 0) {
              resolve()
            } else {
              const done = () => {
                img.removeEventListener('load', done)
                img.removeEventListener('error', done)
                resolve()
              }
              img.addEventListener('load', done)
              img.addEventListener('error', done)
            }
          })
        })

        Promise.all(waitImages).then(() => {
          this.setItemHeight(items)
        })
      })
    }

    setItemHeight(items) {
      const maxHeight = Math.max(...items.map(k => k.offsetHeight))
      items.forEach(t => {
        t.style.height = maxHeight + 'px'
      })
    }

    // ⭐关键：监听元素尺寸变化（比监听 window 高级太多）
    observeResize() {
      this.ro = new ResizeObserver(this.debouncedRecalc)
      this.ro.observe(this)

      // 兼容某些极端场景
      window.addEventListener('resize', this.debouncedRecalc)
    }

    // 防抖
    debounce(fn, delay) {
      let timer = null
      return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => fn.apply(this, args), delay)
      }
    }
  })

  customElements.define(
    "pre-animation",
    class PreAnimation extends HTMLElement {
      constructor() {
        super();
        this.delay = 300;
        this.ticking = false;
        this.onScroll = this.onScroll.bind(this);
        this.recalc = this.debounce(() => this.initContent(), 200);
      }

      connectedCallback() {
        this.waitImages().then(() => {
          this.initContent();
          this.observeResize();
          this.observeEnter();
        });
      }

      disconnectedCallback() {
        window.removeEventListener("scroll", this.onScroll);
        this.ro && this.ro.disconnect();
        this.io && this.io.disconnect();
      }

      // ✅ 等图片稳定（缓存/失败都算）
      waitImages() {
        const firstItem = this.querySelector(".scroll-animation-item-first");
        const images = Array.from(firstItem.querySelectorAll("img"));

        if (!images.length) return Promise.resolve();

        return Promise.all(
          images.map(
            (img) =>
              new Promise((resolve) => {
                if (img.complete && img.naturalWidth !== 0) return resolve();
                const done = () => {
                  img.removeEventListener("load", done);
                  img.removeEventListener("error", done);
                  resolve();
                };
                img.addEventListener("load", done);
                img.addEventListener("error", done);
              })
          )
        );
      }

      // ✅ 真正只算一次几何信息
      initContent() {
        this.itemContent = this.querySelector(
          ".scroll-animation-item-content"
        );
        const firstItem = this.querySelector(
          ".scroll-animation-item-first"
        );
        const scrollAnimationContent = this.querySelector(
          ".scroll-animation-content"
        );

        this.items = Array.from(
          this.querySelectorAll(".scroll-animation-item")
        );

        this.itemHeight = firstItem.getBoundingClientRect().height;

        scrollAnimationContent.style.top = `calc((100vh - ${this.itemHeight}px) / 2)`;

        this.moduleTop =
          this.getBoundingClientRect().top + window.scrollY;

        this.animationArr = this.items.map((dom, index) => {
          const scrollStart =
            this.moduleTop + this.delay + this.itemHeight * index;
          const scrollEnd =
            this.moduleTop +
            this.delay +
            this.itemHeight * (index + 1);
          return [dom, { scrollStart, scrollEnd }];
        });

        const totalScroll =
          this.itemHeight +
          this.itemHeight * this.items.length +
          this.items.length * this.delay;

        this.style.height = totalScroll + "px";
      }

      // ✅ 进入视口才开始监听 scroll
      observeEnter() {
        this.io = new IntersectionObserver((entries) => {
          if (entries[0].isIntersecting) {
            window.addEventListener("scroll", this.onScroll);
          } else {
            window.removeEventListener("scroll", this.onScroll);
          }
        });
        this.io.observe(this);
      }

      // ✅ rAF 节流 scroll（极关键）
      onScroll() {
        if (!this.ticking) {
          requestAnimationFrame(() => {
            this.renderScroll();
            this.ticking = false;
          });
          this.ticking = true;
        }
      }

      renderScroll() {
        const scrollY = window.scrollY;

        for (let i = 0; i < this.animationArr.length; i++) {
          const [dom, { scrollStart, scrollEnd }] =
            this.animationArr[i];

          if (scrollY > scrollStart && scrollY <= scrollEnd) {
            dom.classList.add("active");
            this.itemContent.classList.remove("active");
          } else if (
            i === this.animationArr.length - 1 &&
            scrollY > scrollEnd
          ) {
            dom.classList.add("active");
            this.itemContent.classList.remove("active");
          } else {
            dom.classList.remove("active");
            this.itemContent.classList.add("active");
          }
        }
      }

      // ✅ 元素尺寸变化自动重算（图片懒加载/字体）
      observeResize() {
        this.ro = new ResizeObserver(this.recalc);
        this.ro.observe(this);
        window.addEventListener("resize", this.recalc);
      }

      debounce(fn, delay) {
        let timer;
        return (...args) => {
          clearTimeout(timer);
          timer = setTimeout(() => fn.apply(this, args), delay);
        };
      }
    }
  );

  // 旧版横滑对比（section-parame-pps 仍在使用，保留）
  customElements.define("parame-comparison-fixed", class ParameComparisonSticky extends HTMLElement {
    constructor() {
      super();
      this.header = document.querySelector(".header__container")
      this.headerContainer = document.querySelector('.header-v2--container')
      this.announcement = document.querySelector(".header-announcement--container");
      this.comparisonFixed = this.querySelector(".parame-comparison-fixed")
      this.headerHeight = 0;
      this.headerContainerHeight = 0;
      this.lastScrollY = window.scrollY;
      this.ticking = false;
      this.scrollThreshold = 5;
      this._scrollHandler = null;
      this._resizeObserver = null;
      this._observers = [];
      this.observeResize()
      this.measure()
      this.updateTransform()
      this.bindScroll()
      this.init()
    }

    init() {
      this._comparisonWrapper = this.querySelector(".parame-comparison-fixed-wrapper")
      const comparisonHeader = this.querySelector('.comparison-header')
      const comparisonHeaderTitle = comparisonHeader.querySelector(".auto-height-title")
      this._swiper = this.querySelector(`#${this.dataset.swiperId}`).swiper
      this._swiper.on("setTranslate", (_, translate) => {
        this._comparisonWrapper.style.transform = `translate3d(${translate}px, 0px, 0px)`
      })

      this._resetGrid()

      this._resizeGridHandler = () => this._resetGrid()
      document.addEventListener("windowResize", this._resizeGridHandler)

      this._observers.push(
        this._makeClassObserver(comparisonHeaderTitle, "open", true),
        this._makeClassObserver(this.querySelector(".swiper-wrapper"), "active", false)
      )
    }

    _resetGrid() {
      const slideWidth = this._swiper.slides[0]?.offsetWidth
      if (slideWidth) {
        this._comparisonWrapper.style.gridTemplateColumns = `repeat(${this.dataset.size}, ${slideWidth}px)`
      }
    }

    _makeClassObserver(element, className, invertIntersecting) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          const active = invertIntersecting ? !entry.isIntersecting : entry.isIntersecting;
          this.comparisonFixed.classList.toggle(className, active)
        });
      });
      observer.observe(element)
      return observer
    }

    updateTransform(isScrollDown) {
      if (isScrollDown) {
        this.comparisonFixed.style.top = this.dataset.templateType === "product"
          ? `0px`
          : `${this.headerContainerHeight}px`
      } else {
        this.comparisonFixed.style.top = `${this.headerHeight}px`
      }
    }

    bindScroll() {
      this._scrollHandler = () => {
        if (!this.ticking) {
          requestAnimationFrame(() => {
            this.handleScroll();
            this.ticking = false;
          });
          this.ticking = true;
        }
      };
      window.addEventListener("scroll", this._scrollHandler, { passive: true });
    }

    handleScroll() {
      const currentY = window.scrollY;
      const delta = currentY - this.lastScrollY;
      if (Math.abs(delta) < this.scrollThreshold) return;
      this.updateTransform(delta > 0);
      this.lastScrollY = currentY;
    }

    measure() {
      this.headerContainerHeight = this.headerContainer.offsetHeight;
      this.headerHeight = this.header.offsetHeight;
    }

    observeResize() {
      const targets = [this.header, this.announcement].filter(Boolean);
      this._resizeObserver = new ResizeObserver(() => this.measure());
      targets.forEach(el => this._resizeObserver.observe(el));
    }

    disconnectedCallback() {
      if (this._scrollHandler) {
        window.removeEventListener("scroll", this._scrollHandler);
      }
      if (this._resizeGridHandler) {
        document.removeEventListener("windowResize", this._resizeGridHandler);
      }
      if (this._resizeObserver) {
        this._resizeObserver.disconnect();
      }
      this._observers.forEach(o => o.disconnect());
    }
  })

  // 产品参数对比：固定列 + 下拉切换（PC 3 列 / 移动 2 列）
  customElements.define("parame-comparison", class ParameComparison extends HTMLElement {
    constructor() {
      super();
      // header 相关（用于吸顶偏移）
      this.header = document.querySelector(".header__container");
      this.headerContainer = document.querySelector(".header-v2--container");
      this.announcement = document.querySelector(".header-announcement--container");
      this.headerHeight = 0;
      this.headerContainerHeight = 0;
      this.lastScrollY = window.scrollY;
      this.ticking = false;
      this.scrollThreshold = 5;
      this._scrollHandler = null;
      this._resizeObserver = null;

      this.total = parseInt(this.dataset.total, 10) || 0;
      this.pcColumns = parseInt(this.dataset.pcColumns, 10) || 3;
      this.mdColumns = parseInt(this.dataset.mdColumns, 10) || 2;
      this.mql = window.matchMedia("(min-width: 900px)");

      // DOM 引用
      this.pool = this.querySelector(".comparison-pool");
      this.headSlots = Array.from(this.querySelectorAll(".comparison-slot-head"));
      this.bodySlots = Array.from(this.querySelectorAll(".comparison-slot-body"));
      this.autoHeight = this.querySelector("auto-height");
      this.stickyEl = this.querySelector(".comparison-sticky");

      // 每列当前显示的产品索引；默认前 N 个
      this.slotState = [];
      for (let i = 0; i < this.headSlots.length; i++) {
        this.slotState[i] = i < this.total ? i : -1;
      }

      this._onDocClick = this._onDocClick.bind(this);
      this._onMediaChange = this._onMediaChange.bind(this);
    }

    connectedCallback() {
      // 按当前断点初始化各列（隐藏列不占用卡片）
      this._reconcileSlots();
      this._bindDropdowns();
      this.refreshDropdowns();

      document.addEventListener("click", this._onDocClick);
      this.mql.addEventListener("change", this._onMediaChange);

      // 吸顶
      this.observeResize();
      this.measure();
      this.updateStickyTop();
      this.bindScroll();
      this._updateStuck();

      this._recalcHeights();
    }

    disconnectedCallback() {
      document.removeEventListener("click", this._onDocClick);
      this.mql.removeEventListener("change", this._onMediaChange);
      if (this._scrollHandler) window.removeEventListener("scroll", this._scrollHandler);
      if (this._resizeObserver) this._resizeObserver.disconnect();
    }

    // 当前可见列数（移动 2 / PC 3）
    get visibleColumns() {
      return this.mql.matches ? this.pcColumns : this.mdColumns;
    }

    // 当前可见列所显示的产品索引集合
    get visibleIndexes() {
      const set = new Set();
      for (let i = 0; i < this.visibleColumns; i++) {
        if (this.slotState[i] >= 0) set.add(this.slotState[i]);
      }
      return set;
    }

    // 把产品卡从 pool 移入指定列 body
    _mountCard(slot, productIndex) {
      const body = this.bodySlots[slot];
      if (!body) return;
      // 先把该 body 里已有的卡片放回 pool
      const existing = body.querySelector(".comparison-card");
      if (existing) this.pool.appendChild(existing);
      const card = this.pool.querySelector(`.comparison-card[data-product-index="${productIndex}"]`);
      if (card) body.appendChild(card);
      this.slotState[slot] = productIndex;
      this._syncLabel(slot);
    }

    _syncLabel(slot) {
      const head = this.headSlots[slot];
      if (!head) return;
      const label = head.querySelector(".comparison-dropdown-label");
      const option = head.querySelector(`.comparison-dropdown-option[data-product-index="${this.slotState[slot]}"]`);
      if (label && option) label.textContent = option.textContent.trim();
    }

    _bindDropdowns() {
      this.headSlots.forEach((head, slot) => {
        const dropdown = head.querySelector(".comparison-dropdown");
        const toggle = head.querySelector(".comparison-dropdown-toggle");
        toggle.addEventListener("click", (e) => {
          e.stopPropagation();
          const willOpen = !dropdown.classList.contains("open");
          this._closeAll();
          dropdown.classList.toggle("open", willOpen);
        });
        head.querySelectorAll(".comparison-dropdown-option").forEach((option) => {
          option.addEventListener("click", (e) => {
            e.stopPropagation();
            if (option.classList.contains("is-disabled")) return;
            const productIndex = parseInt(option.dataset.productIndex, 10);
            if (productIndex === this.slotState[slot]) {
              dropdown.classList.remove("open");
              return;
            }
            this._mountCard(slot, productIndex);
            dropdown.classList.remove("open");
            this.refreshDropdowns();
            this._recalcHeights();
          });
        });
      });
    }

    _closeAll() {
      this.querySelectorAll(".comparison-dropdown.open").forEach((d) => d.classList.remove("open"));
    }

    _onDocClick() {
      this._closeAll();
    }

    // 重算下拉禁用/选中状态
    refreshDropdowns() {
      const visible = this.visibleIndexes;
      this.headSlots.forEach((head, slot) => {
        const current = this.slotState[slot];
        head.querySelectorAll(".comparison-dropdown-option").forEach((option) => {
          const idx = parseInt(option.dataset.productIndex, 10);
          const isCurrent = idx === current;
          // 已在其它可见列显示的产品禁用（本列当前项除外）
          const disabled = !isCurrent && visible.has(idx);
          option.classList.toggle("is-disabled", disabled);
          option.classList.toggle("is-selected", isCurrent);
          option.setAttribute("aria-disabled", disabled ? "true" : "false");
        });
      });
    }

    // 按当前断点对齐各列：可见列各持有一个不重复的产品，隐藏列把卡片交回 pool
    _reconcileSlots() {
      const visibleCount = this.visibleColumns;
      const used = new Set();

      // 1. 可见列：若当前产品无效或与其它可见列重复，则改用下一个未占用产品
      for (let slot = 0; slot < visibleCount; slot++) {
        let idx = this.slotState[slot];
        if (idx < 0 || idx >= this.total || used.has(idx)) {
          idx = -1;
          for (let cand = 0; cand < this.total; cand++) {
            if (!used.has(cand)) { idx = cand; break; }
          }
        }
        if (idx >= 0) {
          used.add(idx);
          if (this.bodySlots[slot].querySelector(".comparison-card")?.dataset.productIndex != idx) {
            this._mountCard(slot, idx);
          } else {
            this.slotState[slot] = idx;
            this._syncLabel(slot);
          }
        }
      }

      // 2. 隐藏列：把卡片交回 pool（避免占用 DOM 节点导致可见列取不到）
      for (let slot = visibleCount; slot < this.bodySlots.length; slot++) {
        const existing = this.bodySlots[slot].querySelector(".comparison-card");
        if (existing) this.pool.appendChild(existing);
        this.slotState[slot] = -1;
      }
    }

    _onMediaChange() {
      // 断点切换：重新对齐各列、重算禁用状态与行高
      this._reconcileSlots();
      this.refreshDropdowns();
      this.measure();
      this.updateStickyTop();
      this._recalcHeights();
    }

    // 触发 auto-height 重算
    _recalcHeights() {
      // auto-height 监听 ResizeObserver + windowResize，DOM 变更后主动触发
      requestAnimationFrame(() => {
        document.dispatchEvent(new CustomEvent("windowResize"));
        window.dispatchEvent(new Event("resize"));
      });
    }

    // ===== 吸顶偏移 =====
    updateStickyTop(isScrollDown) {
      let top;
      if (isScrollDown) {
        top = this.dataset.templateType === "product" ? 0 : this.headerContainerHeight;
      } else {
        top = this.headerHeight;
      }
      this.style.setProperty("--comparison-sticky-top", `${top}px`);
    }

    bindScroll() {
      this._scrollHandler = () => {
        if (!this.ticking) {
          requestAnimationFrame(() => {
            this.handleScroll();
            this.ticking = false;
          });
          this.ticking = true;
        }
      };
      window.addEventListener("scroll", this._scrollHandler, { passive: true });
    }

    handleScroll() {
      const currentY = window.scrollY;
      // 卡住检测每帧都跑（不受滚动阈值限制），供 CSS .is-stuck 切换背景
      this._updateStuck();
      const delta = currentY - this.lastScrollY;
      if (Math.abs(delta) < this.scrollThreshold) return;
      this.updateStickyTop(delta > 0);
      this.lastScrollY = currentY;
    }

    // 吸顶行是否已“卡住”：其实际 top 贴到吸顶偏移即视为卡住
    _updateStuck() {
      if (!this.stickyEl) return;
      const stickyTop = parseFloat(getComputedStyle(this).getPropertyValue("--comparison-sticky-top")) || 0;
      const rectTop = this.stickyEl.getBoundingClientRect().top;
      // 留 1px 容差
      const stuck = rectTop <= stickyTop + 1;
      this.stickyEl.classList.toggle("is-stuck", stuck);
    }

    measure() {
      this.headerContainerHeight = this.headerContainer ? this.headerContainer.offsetHeight : 0;
      this.headerHeight = this.header ? this.header.offsetHeight : 0;
    }

    observeResize() {
      const targets = [this.header, this.announcement].filter(Boolean);
      if (!targets.length) return;
      this._resizeObserver = new ResizeObserver(() => {
        this.measure();
        this.updateStickyTop();
      });
      targets.forEach((el) => this._resizeObserver.observe(el));
    }
  })

  customElements.define("pre-customize", class PreCustomize extends HTMLElement {
    constructor() {
      super();

      // 产品规则
      this.PRODUCTS = [
        { resultIndex: 0, q1: 0, powerRange: [0, 1, 2] }, // 2400 Pro, YES
        { resultIndex: 1, q1: 1, powerRange: [1, 2] },   // 2400 AC+, NO
        { resultIndex: 2, q1: 1, powerRange: [0, 1] },   // 1600 AC+, NO
        { resultIndex: 3, q1: [0, 1], powerRange: [3] }  // Mehrsystem, >2400W
      ];

      this.productMap = ['SolarFlow 2400 Pro', 'SolarFlow 2400 AC+', 'SolarFlow 1600 AC+', 'SolarFlow Mehrsystem-Lösung']

      this.state = {
        q1: null,    // 第一题
        power: null, // 第二题
        results: []  // 推荐结果
      };
    }

    connectedCallback() {
      this.cache();
      this.bind();
    }

    cache() {
      this.q1Items = [...this.querySelectorAll('[data-q1-index]')];
      this.q2Items = [...this.querySelectorAll('[data-q2-index]')];
      this.resultItems = [...this.querySelectorAll('[data-result-index]')];
      this.hiddenInputs = document.querySelectorAll('input[data-pre-tag]');
    }

    bind() {
      // 第一题
      this.q1Items.forEach(el => {
        el.addEventListener('click', () => {
          this.state.q1 = +el.dataset.q1Index;
          if (this.state.power === null) this.state.power = 0;
          this.computeResults();
        });
      });

      // 第二题
      this.q2Items.forEach(el => {
        el.addEventListener('click', () => {
          this.state.power = +el.dataset.q2Index;
          if (this.state.q1 === null) this.state.q1 = 0;
          this.computeResults();
        });
      });

      // 第三题反推
      this.resultItems.forEach(el => {
        el.addEventListener('click', () => {
          const idx = +el.dataset.resultIndex;
          this.reverseByResult(idx);
        });
      });
    }

    // 核心计算推荐
    computeResults() {
      const { q1, power } = this.state;
      if (q1 === null || power === null) return;

      const results = this.PRODUCTS.filter(p => {
        const matchQ1 = Array.isArray(p.q1) ? p.q1.includes(q1) : p.q1 === q1;
        const matchPower = p.powerRange.includes(power);
        return matchQ1 && matchPower;
      }).map(p => p.resultIndex);

      this.state.results = results;
      this.render();
    }

    // 第三题反推
    reverseByResult(resultIndex) {
      const product = this.PRODUCTS.find(p => p.resultIndex === resultIndex);
      if (!product) return;

      // 第一题
      if (Array.isArray(product.q1)) this.state.q1 = 0;
      else this.state.q1 = product.q1;

      // 第二题功率反推到最大支持功率
      this.state.power = Math.max(...product.powerRange);

      this.computeResults();
    }

    // 渲染高亮
    render() {
      // 第一题
      this.q1Items.forEach(el => {
        el.classList.toggle('active', +el.dataset.q1Index === this.state.q1);
      });

      // 第二题阶梯高亮
      this.q2Items.forEach(el => {
        const idx = +el.dataset.q2Index;
        if (this.state.results.includes(3)) {
          // Mehrsystem -> 第二题全部高亮
          el.classList.add('active');
        } else {
          el.classList.toggle('active', idx <= this.state.power);
        }
      });

      // 第三题推荐多选高亮
      this.resultItems.forEach(el => {
        el.classList.toggle(
          'active',
          this.state.results.includes(+el.dataset.resultIndex)
        );
      });

      if (this.hiddenInputs.length) {
        let tags = this.state.results.map(t => this.productMap[t])
        let tagStr = '26Q1Launch,' + tags.join(",")
        this.hiddenInputs.forEach(input => {
          input.value = tagStr
        })
      }
    }
  });

  customElements.define('scroll-sticky', class ScrollSticky extends HTMLElement {
    constructor() {
      super();
      this.delay = 300;
      this.ticking = false;
      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);
    }

    connectedCallback() {
      this.video = this.querySelector('.scroll--video');
      if (!this.video) return;

      this.waitVideoReady(() => {
        this.calculate();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
        this.onScroll(); // 初始化一次
      });
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
    }

    // ✅ 比 loadedmetadata 稳
    waitVideoReady(cb) {
      if (this.video.readyState >= 2) {
        cb();
      } else {
        this.video.addEventListener('loadeddata', cb, { once: true });
      }
    }

    // ✅ 所有布局计算只做这里
    calculate() {
      const rect = this.getBoundingClientRect();
      const scrollTop = window.scrollY;

      this.scrollStart = rect.top + scrollTop + this.delay;
      this.scrollEnd = this.scrollStart + this.video.offsetHeight;
    }

    onResize() {
      this.calculate();
      this.onScroll();
    }

    // ✅ rAF 节流滚动
    onScroll() {
      if (!this.ticking) {
        requestAnimationFrame(() => {
          const scrollY = window.scrollY;
          const opacity = this.mapRange(
            scrollY,
            this.scrollStart,
            this.scrollEnd,
            1,
            0.2
          );
          this.video.style.opacity = opacity;
          this.ticking = false;
        });
        this.ticking = true;
      }
    }

    mapRange(value, start, end, from, to) {
      if (value <= start) return from;
      if (value >= end) return to;
      return ((value - start) / (end - start)) * (to - from) + from;
    }
  });

  /* START MANUALS */
  customElements.define(
    "manuals-section",
    class ManualsSection extends HTMLElement {
      constructor() {
        super();
        this.isDesktop = window.matchMedia('(min-width: 1024px)');
        this.categoryLinks = this.querySelectorAll('.category-link');
        this.gridContainers = this.querySelectorAll('.product-grid-container');
        this.accordionHeaders = this.querySelectorAll('.accordion-header');
        this.searchInput = this.querySelector('#download-search');
        this.productItems = this.querySelectorAll('.download-item');
        this.noResults = this.querySelector('#no-results');

        this.init();
      }

      init() {
        this.initLayout();
        this.bindEvents();
      }

      initLayout() {
        if (this.isDesktop.matches) {
          // Desktop: Show first category grid by default if none active
          let hasActive = false;
          this.categoryLinks.forEach((link) => {
            if (link.classList.contains('active')) {
              const target = link.getAttribute('data-target');
              const targetGrid = this.querySelector('#grid-' + target);
              if (targetGrid) {
                targetGrid.classList.remove('tw-hidden', 'lg:tw-hidden');
                hasActive = true;
              }
            }
          });

          if (!hasActive && this.categoryLinks.length > 0) {
            // Activate first one
            const firstLink = this.categoryLinks[0];
            firstLink.classList.add('active'); // Style handled by CSS
            const target = firstLink.getAttribute('data-target');
            const targetGrid = this.querySelector('#grid-' + target);
            if (targetGrid) targetGrid.classList.remove('tw-hidden', 'lg:tw-hidden');
          }
        }
      }

      bindEvents() {
        // Handle PC Click
        this.categoryLinks.forEach((link) => {
          link.addEventListener('click', () => {
            // Deactivate all
            this.categoryLinks.forEach((l) => l.classList.remove('active'));
            this.gridContainers.forEach((g) => g.classList.add('tw-hidden', 'lg:tw-hidden'));

            // Activate clicked
            link.classList.add('active');
            const target = link.getAttribute('data-target');
            const targetGrid = this.querySelector('#grid-' + target);
            if (targetGrid) targetGrid.classList.remove('tw-hidden', 'lg:tw-hidden');
          });
        });

        // Handle Mobile Click (Accordion)
        this.accordionHeaders.forEach((header) => {
          header.addEventListener('click', () => {
            const target = header.getAttribute('data-target');
            const targetGrid = this.querySelector('#grid-' + target);
            const arrow = header.querySelector('.icon-arrow');

            if (targetGrid.classList.contains('tw-hidden')) {
              // Open
              targetGrid.classList.remove('tw-hidden', 'lg:tw-hidden');
              arrow.classList.add('tw-rotate-180');
            } else {
              // Close
              targetGrid.classList.add('tw-hidden', 'lg:tw-hidden');
              arrow.classList.remove('tw-rotate-180');
            }
          });
        });

        // Search Logic
        if (this.searchInput) {
          this.searchInput.addEventListener('input', (e) => {
            const term = e.target.value.toLowerCase();

            if (term.length > 0) {
              // In search mode, show ALL grids, but filter items
              this.gridContainers.forEach((container) => {
                // Show container first so we can see matching items
                container.classList.remove('tw-hidden', 'lg:tw-hidden');
              });

              let matchCount = 0;
              this.productItems.forEach((item) => {
                const title = item.getAttribute('data-title') || '';
                if (title.includes(term)) {
                  item.classList.remove('tw-hidden');
                  matchCount++;
                } else {
                  item.classList.add('tw-hidden');
                }
              });

              if (matchCount === 0) {
                this.noResults.classList.remove('tw-hidden');
              } else {
                this.noResults.classList.add('tw-hidden');
              }

              // Hide empty grids?
              this.gridContainers.forEach((container) => {
                const visibleItems = container.querySelectorAll('.download-item:not(.tw-hidden)');
                if (visibleItems.length === 0) {
                  container.classList.add('tw-hidden', 'lg:tw-hidden');
                  const sectionId = container.id.replace('grid-', 'section-');
                  const section = this.querySelector('#' + sectionId);
                  if (section) section.classList.add('tw-hidden');
                } else {
                  const sectionId = container.id.replace('grid-', 'section-');
                  const section = this.querySelector('#' + sectionId);
                  if (section) section.classList.remove('tw-hidden');
                }
              });
            } else {
              // Clear search, reset layout
              this.productItems.forEach((item) => item.classList.remove('tw-hidden'));
              this.noResults.classList.add('tw-hidden');

              // Reset sections visibility
              this.querySelectorAll('.category-section').forEach((s) => s.classList.remove('tw-hidden'));

              // Re-run initLayout to restore Tab/Accordion state
              // Reset all first
              this.gridContainers.forEach((g) => g.classList.add('tw-hidden', 'lg:tw-hidden'));

              if (this.isDesktop.matches) {
                this.initLayout();
              } else {
                // Mobile: collapse all?
                this.accordionHeaders.forEach((h) => {
                  h.querySelector('.icon-arrow').classList.remove('tw-rotate-180');
                });
              }
            }
          });
        }
      }
    }
  );

  customElements.define("pps-showcase", class PpsShowcase extends HTMLElement {
    constructor() {
      super()
      this.sectionId = this.id
      this.currentScene = 0
      this.currentTab = 0
      this.productSwiperSlides = Array.from(this.querySelectorAll('.product-swiper-slide'))
      this.productSwiperSlide = this.productSwiperSlides[this.currentTab]
      this.productSwiper = this.querySelector('#product-swiper-' + this.sectionId)
      this.tabsSwiper = this.querySelector('#tabs-swiper-' + this.sectionId)
      this.tabs = this.querySelectorAll(".section-pps-showcase-tab")
    }
    connectedCallback() {
      this.initScene()
      this.initTabs()
      this.initPower()
    }
    initScene() {
      const sceneBtn = this.querySelectorAll(".section-pps-showcase-scene-btn")
      const sceneContainer = this.querySelector(".section-pps-showcase-scene-container")
      sceneBtn.forEach((t, index) => {
        t.addEventListener("click", () => {
          this.currentScene = index
          sceneContainer.classList.toggle('active')
          this.updateTab(index === 0 ? 1 : 0)
          this.productSwiperSlides.forEach((s) => {
            s.querySelector("swiper-component").slideTo(this.currentScene)
          })
        })
      })
    }
    initTabs() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          this.updateTab(index)
        })
      })
    }
    updateTab(index) {
      this.tabs.forEach((t, idx) => {
        t.classList.toggle("active", idx === index)
      })
      this.currentTab = index
      this.productSwiper.slideTo(index)
      this.tabsSwiper.slideTo(index)
      this.productSwiperSlide = this.productSwiperSlides[index]
      this.initPower()

    }
    initPower() {
      const powerInput = this.productSwiperSlide.querySelector(".section-pps-showcase-power")
      powerInput.addEventListener("input", (e) => {
        const maxPower = Number(e.target.dataset.max)
        const capacity = Number(e.target.dataset.capacity ?? 0)
        let power = Number(e.target.value)
        if (power > maxPower) {
          power = maxPower
        }
        e.target.value = power
        const hours = this.productSwiperSlide.querySelector(".section-pps-showcase-hours")
        let pValue = capacity || maxPower
        hours.textContent = power && (pValue / power).toFixed(1)
      })
    }
  })

  customElements.define("mix-showcase", class PpsShowcase extends HTMLElement {
    constructor() {
      super()
    }
    connectedCallback() {
      this.initScene()
    }
    initScene() {
      const sceneBtn = this.querySelectorAll(".section-mix-showcase-scene-btn")
      const sceneContainer = this.querySelector(".section-mix-showcase-scene-container")
      sceneBtn.forEach((t, index) => {
        t.addEventListener("click", () => {
          sceneContainer.classList.toggle('active')
        })
      })
    }
  })

  customElements.define(
    "section-scroll-mix-video",
    class ScrollMixVideo extends HTMLElement {
      constructor() {
        super();
        this.content = this.querySelector("#scroll--content");
        this.canvas = this.querySelector("#scroll--canvas");
        this.textWrad = this.querySelector("#scroll--text");
        this.ctx = this.canvas.getContext("2d");
        this.placeholderImage = this.querySelector("#scroll--image")
        this.frameCount = 39;
        this.frameGap = this.dataset.frameGap || 80;
        this.frameGapMd = this.dataset.frameGapMd || 30;
        this.gap = 0;

      }
      connectedCallback() {
        this.getImages()
        this.init();
      }
      init() {

        this.placeholderImage.onload = () => {
          this.content.style.top = `calc((100vh - ${this.content.clientHeight}px) / 2)`;
          this.scrollSection();
        }
        window.addEventListener("resize", debounce(() => {
          this.linearSize();
          this.content.style.top = `calc((100vh - ${this.content.clientHeight}px) / 2)`;
          this.scrollSection();
        }, 200));
        this.linearSize();
      }

      linearSize() {
        const viewportWidth = this.getWinClientWidth();
        viewportWidth <= 768 ? this.gap = this.frameGapMd : this.gap = this.frameGap
      }

      getImages() {
        // 预加载
        const urlArr = JSON.parse(this.querySelector("template").innerHTML || '[]')
        this.frameCount = urlArr.length
        let loaded = 0;
        this.images = [];
        for (let i = 0; i < urlArr.length; i++) {
          const img = new Image();
          img.src = urlArr[i] + `&width=1920`;
          img.onload = () => {
            loaded++;
            if (loaded === this.frameCount) {
              this.content.classList.remove("loading");
              this.drawCanvas(0);
            };
            this.images[i] = img;
          }
        }
      }

      drawCanvas(index) {
        const img = this.images[index];
        if (!img) return;
        this.canvas.width = img.width;
        this.canvas.height = img.height;
        this.ctx.drawImage(img, 0, 0);
        console.log("index", index)
        this.textWrad.classList[index >= (this.images.length - 2) ? 'add' : 'remove']('active')
        // this.placeholderImage.classList[index > 16 ? "remove" : "add"]("tw-opacity-0");
      }

      scrollSection() {
        const viewportHeight = this.getViewportHeight();
        const scrollContentTop = (viewportHeight - this.content.clientHeight) / 2;
        const totalScroll = this.gap * this.frameCount + this.content.clientHeight + scrollContentTop;
        this.style.height = totalScroll + 'px'

        window.addEventListener("scroll", () => {
          const scrollTop = this.getScrollTop();
          const sectionTop = this.offsetTop;
          const sectionHeight = this.offsetHeight;
          if ((sectionTop - scrollContentTop) < scrollTop && (sectionTop + sectionHeight - scrollContentTop) > scrollTop) {
            const scrollY = scrollTop - sectionTop;
            let index = Math.min(
              this.frameCount - 1,
              Math.floor(scrollY / this.gap)
            );
            index = Math.max(0, index);
            this.drawCanvas(index);
          }
        });

      }
      // https://cdn.shopify.com/s/files/1/0550/5312/3661/files/new_800plus_010.png?v=1764406949
      framePath(index) {
        return `https://cdn.shopify.com/s/files/1/0550/5312/3661/files/new_800plus_${String(index).padStart(3, '0')}.png?width=1920&v=1764407110969`;
      }

      getViewportHeight() {
        return window.innerHeight ||
          document.documentElement.clientHeight ||
          document.body.clientHeight ||
          0;
      }

      getWinClientWidth() {
        return (
          document.documentElement.clientWidth || document.body.clientWidth
        );
      }

      getScrollTop() {
        return window.pageYOffset ||
          document.documentElement.scrollTop ||
          document.body.scrollTop ||
          0;
      }
    }
  );

  customElements.define('share-ugc-content', class ShareUgcContent extends HTMLElement {
    connectedCallback() {
      if (this.getClientWidth() <= 768) {
        this.initExpandButtons()
      }
      this.initZoomGallery()
    }

    getClientWidth() {
      return document.documentElement.clientWidth || document.body.clientWidth
    }

    initZoomGallery() {
      const modal = this.querySelector('global-modal')
      const swiperZoom = this.querySelector('#section-share-ugc-swiper-zoom')
      const swiperContent = this.querySelector('#section-share-ugc-swiper-content')
      const shareContainers = this.querySelectorAll('.share-item--container')
      const shareContents = this.querySelectorAll('.share-item--content')


      if (!modal || !swiperZoom) return
      const swiperZoomWrapper = swiperZoom.querySelector('.swiper-wrapper')
      const zoomImages = []
      shareContainers.forEach((container, index) => {
        const images = container.querySelectorAll('.share-item-sub-zoom-img')
        zoomImages.push(...images)
        images.forEach((img, i) => {
          const slide = document.createElement('div')
          slide.className = 'swiper-slide'
          slide.dataset.index = `${index}`
          const image = new Image()
          image.src = img.dataset.src
          image.className = 'zoomed-image tw-mx-auto tw-w-full tw-h-full tw-object-contain'
          slide.appendChild(image)
          swiperZoomWrapper.appendChild(slide)
        })
      })


      this.addEventListener('click', (e) => {
        const img = e.target.closest('.share-item-sub-zoom-img')
        if (!img) return
        const index = [...zoomImages].indexOf(img)
        this.initswiper(swiperZoom, swiperContent)
        swiperZoom.slideTo(index)
        modal.open = true
        document.body.classList.add('overflow-hidden')
      })


      const swiperContentWrapper = swiperContent.querySelector('.swiper-wrapper')
      shareContents.forEach(container => {
        const slide = document.createElement('div')
        slide.className = 'swiper-slide share-content-swiper-slide'
        slide.appendChild(container.cloneNode(true))
        swiperContentWrapper.appendChild(slide)
      })
    }

    initswiper(swiperZoom, swiperContent) {
      if (!swiperContent.open) {
        swiperContent.open = true
      }
      if (!swiperZoom.open) {
        swiperZoom.open = true
        swiperZoom.swiper.on('slideChange', (e, ee) => {
          swiperContent.slideTo(e.slides[e.activeIndex].dataset.index)
        })
      }

    }
    initExpandButtons() {
      this.querySelectorAll('.share-item--content').forEach(container => {
        const avatar = container.querySelector('.share-item-avatar')
        const content = container.querySelector('.share-item--text')
        // if (!avatar || !content) return

        const availableHeight = container.offsetHeight - avatar.offsetHeight - 75
        if (content.offsetHeight <= availableHeight) return

        requestAnimationFrame(() => {
          const btn = document.createElement('button')
          btn.type = 'button'
          btn.className = 'expand-content-btn'
          btn.textContent = this.dataset.moreText
          content.insertAdjacentElement('afterend', btn)
          btn.addEventListener('click', () => {
            content.classList.toggle('is-expanded')
            btn.textContent = content.classList.contains('is-expanded')
              ? this.dataset.lessText
              : this.dataset.moreText
          })
        })
      })
    }
  })


  customElements.define("scenario-variant-change", class ProductVariants extends HTMLElement {
    constructor() {
      super()
      this.cache = {
        priceEl: this.querySelector(".product__black-price"),
        priceAtEl: this.querySelector('.product__black-at-price'),
        moreBtnEl: this.querySelector('.product__black-more'),
        amounWardtEl: this.querySelector(".product__black-amount-ward"),
        amountEl: this.querySelector(".product__black-amount")
      }
    }
    connectedCallback() {
      const _this = this
      this.addEventListener('click', (e) => {
        const item = e.target.closest('.product-variant--item')
        if (!item || item.disabled) return
        this.querySelectorAll('.product-variant--item').forEach(el => el.classList.remove('active'))
        item.classList.add('active')
        _this.variantChange(item)
      })
    }

    variantChange(item) {
      const { price, variantId, url, atPrice } = item.dataset
      let discountAmount = atPrice - price
      const klarnaPlacement = this.querySelector('klarna-placement')
      const addCartButtonEl = this.querySelector("add-cart-button")
      if (klarnaPlacement) {
        klarnaPlacement.setAttribute('data-purchase-amount', price)
      }
      if (addCartButtonEl) {
        addCartButtonEl.setAttribute('data-variant-id', variantId)
      }
      this.cache.priceEl.innerText = theme.Currency.formatMoney(
        price,
        theme.settings.moneyFormat
      )
      this.cache.moreBtnEl.setAttribute('href', url)

      this.cache.priceAtEl.innerText = theme.Currency.formatMoney(
        atPrice,
        theme.settings.moneyFormat
      )
      this.cache.amountEl.innerText = '-' + theme.Currency.formatMoney(
        discountAmount,
        theme.settings.moneyFormat
      )

      this.cache.priceAtEl.classList[discountAmount > 0 ? 'remove' : 'add']('tw-hidden')
      this.cache.amounWardtEl.classList[discountAmount > 0 ? 'remove' : 'add']('tw-hidden')

    }

  })


  customElements.define("section-home-collections", class SectionHomeCollections extends HTMLElement {
    constructor() {
      super()
      this.UPSELL_ITEM_SELECTOR = ".home-collections-upsell-item"
      this.CARD_SELECTOR = "[data-home-collections-card]"
    }

    connectedCallback() {
      this.addEventListener("click", (event) => {
        const item = event.target.closest(this.UPSELL_ITEM_SELECTOR)
        if (!item || !this.contains(item)) return

        const card = item.closest(this.CARD_SELECTOR)
        if (!card || !this.contains(card)) return

        // 再次点击已选中项 = 取消勾选
        this.select(card, item.classList.contains("active") ? null : item)
      })
    }

    select(card, item) {
      card.querySelectorAll(this.UPSELL_ITEM_SELECTOR).forEach((el) => {
        const on = el === item
        el.classList[on ? 'add' : 'remove']('active')
        el.setAttribute('aria-pressed', on ? 'true' : 'false')
      })

      this.updatePrice(card, item)

      const addCartButtonEl = card.querySelector("add-cart-button")
      if (!addCartButtonEl) return

      const variantId = item && item.dataset.id
      if (variantId) {
        addCartButtonEl.setAttribute("data-freebie-id", variantId)
      } else {
        addCartButtonEl.removeAttribute("data-freebie-id")
      }
    }

    // 卡片价格 = 主商品变体价 + 选中换购价（取消勾选回落到变体价）
    updatePrice(card, item) {
      const priceEl = card.querySelector("[data-base-price]")
      if (!priceEl) return

      const basePrice = Number(priceEl.dataset.basePrice) || 0
      const addonPrice = item ? Number(item.dataset.price) || 0 : 0
      priceEl.innerText = theme.Currency.formatMoney(
        basePrice + addonPrice,
        theme.settings.moneyFormat
      )
    }
  })

  customElements.define("section-black-products", class SectionBlackProducts extends HTMLElement {
    constructor() {
      super()
      this.BUNDLE_ITEM_SELECTOR = ".section-product-bundle-item"
      this.CARD_SELECTOR = "[data-black-product-card]"
    }

    connectedCallback() {
      this.addEventListener("click", (event) => {
        const item = event.target.closest(this.BUNDLE_ITEM_SELECTOR)
        if (!item || !this.contains(item)) return

        const card = item.closest(this.CARD_SELECTOR)
        if (!card || !this.contains(card)) return

        this.select(card, item.classList.contains("active") ? null : item)
      })
    }

    select(card, item) {
      card.querySelectorAll(this.BUNDLE_ITEM_SELECTOR).forEach((el) => {
        const on = el === item
        el.classList[on ? 'add' : 'remove']('active')
        el.setAttribute('aria-pressed', on ? 'true' : 'false')
      })

      this.updatePrice(card, item)

      const addCartButtonEl = card.querySelector("add-cart-button")
      if (!addCartButtonEl) return

      const variantId = item && item.dataset.id
      if (variantId) {
        addCartButtonEl.setAttribute("data-freebie-id", variantId)
      } else {
        addCartButtonEl.removeAttribute("data-freebie-id")
      }
    }

    updatePrice(card, item) {
      const priceEl = card.querySelector(".product__black-price")
      if (!priceEl) return

      const basePrice = Number(priceEl.dataset.basePrice) || 0
      const addonPrice = item ? Number(item.dataset.price) || 0 : 0
      priceEl.innerText = theme.Currency.formatMoney(
        basePrice + addonPrice,
        theme.settings.moneyFormat
      )
    }
  })

  customElements.define("section-product-bundle", class SectionProductBundle extends HTMLElement {
    constructor() {
      super()
      this.BUNDLE_ITEM_SELECTOR = ".section-product-bundle-item"
    }
    connectedCallback() {
      // 初始不勾选任何项，显示第 0 张兜底场景图
      this.selectedItem = null

      // 事件委托：后台增删 block 时无需重新绑定
      this.addEventListener("click", (event) => {
        const item = event.target.closest(this.BUNDLE_ITEM_SELECTOR)
        if (!item || !this.contains(item)) return
        // 再次点击已选中项 = 取消勾选
        this.select(item === this.selectedItem ? null : item)
      })

      this.select(null)
    }

    select(item) {
      this.selectedItem = item

      const items = this.querySelectorAll(this.BUNDLE_ITEM_SELECTOR)
      items.forEach((el) => {
        const on = el === item
        el.classList[on ? 'add' : 'remove']('active')
        el.setAttribute('aria-pressed', on ? 'true' : 'false')
      })

      // slide 0 是兜底场景图，block 的场景图从 1 开始，所以选中项要 +1
      // 这些 item 不挂 swiper-tab-item，跳转完全由这里接管，避免 swiper 先切错再被纠正
      const swiperEl = this.querySelector("swiper-component")
      if (swiperEl && swiperEl.swiper) {
        const index = item ? Array.prototype.indexOf.call(items, item) + 1 : 0
        swiperEl.slideTo(index)
      }

      this.updatePrice(item)

      const addCartButtonEl = this.querySelector("add-cart-button")
      if (!addCartButtonEl) return

      const variantId = item && item.dataset.id
      if (variantId) {
        addCartButtonEl.setAttribute("data-freebie-id", variantId)
      } else {
        addCartButtonEl.removeAttribute("data-freebie-id")
      }
    }

    // 主价格 = 变体价 + 选中项换购价（取消勾选则回落到变体价）
    // 划线价同步浮动，保持折扣差额恒定
    updatePrice(item) {
      const priceEl = this.querySelector(".section-product-bundle-price")
      const crossedPriceEl = this.querySelector(".section-product-bundle-crossed-price")
      if (!priceEl) return

      const basePrice = Number(priceEl.dataset.basePrice) || 0
      const addonPrice = item ? Number(item.dataset.price) || 0 : 0
      const finalPrice = basePrice + addonPrice

      priceEl.innerText = theme.Currency.formatMoney(
        finalPrice,
        theme.settings.moneyFormat
      )

      if (crossedPriceEl) {
        const baseCrossedPrice = Number(crossedPriceEl.dataset.baseCrossedPrice) || 0
        crossedPriceEl.innerText = theme.Currency.formatMoney(
          baseCrossedPrice + addonPrice,
          theme.settings.moneyFormat
        )
      }
    }
  })
  // scenario-26：多变体切换 + 换购共存。
  // 两者都影响主价格，所以统一在这里算：主价 = 选中变体价 + 换购价。
  // 不复用 scenario-variant-change / section-black-products：前者直接写死变体价会抹掉换购加价，
  // 后者的 data-base-price 是渲染时写死的，变体切换后不会更新。
  // scenario-26：可选加购产品（单选）+ 换购（单选）。
  // 可选项每条自带产品与价格，同时只能选一条；主价 = 选中项价格 + 换购价。
  customElements.define("scenario-26-variants", class Scenario26Variants extends HTMLElement {
    constructor() {
      super()
      this.OPTION_SELECTOR = '.product-variant--item'
      this.BUNDLE_SELECTOR = '.section-product-bundle-item'
      this.bundleItem = null   // 选中的换购项，null = 未勾选
    }

    connectedCallback() {
      this.priceEl = this.querySelector('.product__black-price')
      this.atPriceEl = this.querySelector('.product__black-at-price')
      this.moreBtnEl = this.querySelector('.product__black-more')
      this.addCartEl = this.querySelector('add-cart-button')
      this.klarnaEl = this.querySelector('klarna-placement')
      this.discountEl = this.querySelector('.product-template-discount-amount')

      this.addEventListener('click', (e) => {
        const option = e.target.closest(this.OPTION_SELECTOR)
        if (option && this.contains(option)) {
          // data-disabled 存的是 variant.available，'false' = 缺货
          if (option.dataset.disabled === 'false') return
          this.selectOption(option)
          return
        }
        const bundle = e.target.closest(this.BUNDLE_SELECTOR)
        if (bundle && this.contains(bundle)) {
          // 再次点击已选中项 = 取消勾选
          this.selectBundle(bundle === this.bundleItem ? null : bundle)
        }
      })
    }

    get options() {
      return Array.prototype.slice.call(this.querySelectorAll(this.OPTION_SELECTOR))
    }

    get selected() {
      return this.options.filter((el) => el.classList.contains('active'))
    }

    // 单选：点中的置为选中，其余取消。再次点已选项不做处理（不允许全不选）
    selectOption(item) {
      if (item.classList.contains('active')) return
      this.options.forEach((el) => {
        const on = el === item
        el.classList[on ? 'add' : 'remove']('active')
        el.setAttribute('aria-pressed', on ? 'true' : 'false')
      })
      this.render()
    }

    selectBundle(item) {
      this.bundleItem = item
      this.querySelectorAll(this.BUNDLE_SELECTOR).forEach((el) => {
        const isOn = el === item
        el.classList[isOn ? 'add' : 'remove']('active')
        el.setAttribute('aria-pressed', isOn ? 'true' : 'false')
      })

      if (this.addCartEl) {
        const id = item && item.dataset.id
        if (id) this.addCartEl.setAttribute('data-freebie-id', id)
        else this.addCartEl.removeAttribute('data-freebie-id')
      }
      this.render()
    }

    money(cents) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat)
    }

    // 折扣标签在 Liquid 里用的是 money_without_trailing_zeros（整数金额不带小数位），
    // formatMoney 走 shop.money_format 会带 ,00，两边对不上。整数时换成 no_decimals 占位符。
    moneyNoTrailingZeros(cents) {
      const fmt = theme.settings.moneyFormat || ''
      if (cents % 100 === 0) {
        const noDecimals = fmt
          .replace('amount_with_comma_separator', 'amount_no_decimals_with_comma_separator')
          .replace('amount_with_space_separator', 'amount_no_decimals_with_space_separator')
          .replace(/\{\{\s*amount\s*\}\}/, '{{ amount_no_decimals }}')
        return theme.Currency.formatMoney(cents, noDecimals)
      }
      return this.money(cents)
    }

    render() {
      const picked = this.selected
      const addon = this.bundleItem ? Number(this.bundleItem.dataset.price) || 0 : 0

      let total = 0
      let crossedTotal = 0
      if (this.options.length) {
        // 可选加购模式：主价 = 选中项价格（单选，picked 最多一条）
        picked.forEach((el) => {
          const price = Number(el.dataset.price) || 0
          const at = Number(el.dataset.atPrice) || 0
          total += price
          // 没有划线价的项按原价计入，保证差额只来自真正有折扣的项
          crossedTotal += at > price ? at : price
        })
      } else {
        // 原换购模式：主价 = Liquid 写入的基准价，换购项在其上加价
        total = Number(this.priceEl && this.priceEl.dataset.basePrice) || 0
        const baseCrossed = Number(this.atPriceEl && this.atPriceEl.dataset.baseCrossedPrice) || 0
        crossedTotal = baseCrossed > total ? baseCrossed : total
      }

      if (this.priceEl) this.priceEl.innerText = this.money(total + addon)
      if (this.klarnaEl) this.klarnaEl.setAttribute('data-purchase-amount', total + addon)

      if (this.atPriceEl) {
        const show = crossedTotal > total
        if (show) this.atPriceEl.innerText = this.money(crossedTotal + addon)
        this.atPriceEl.classList[show ? 'remove' : 'add']('tw-hidden')
      }

      // 折扣标签：差额只按可选项算，换购加价两边都加所以不影响
      if (this.discountEl) {
        const diff = crossedTotal - total
        const amountEl = this.discountEl.querySelector('[data-discount-amount]')
        if (amountEl) amountEl.innerText = '- ' + this.moneyNoTrailingZeros(diff)
        this.discountEl.classList[diff > 0 ? 'remove' : 'add']('tw-opacity-0')
      }

      // 加购：选中项即主商品。
      // 原换购模式没有可选项，data-variant-id 保持 Liquid 渲染的主产品不动。
      if (this.addCartEl && picked.length && picked[0].dataset.variantId) {
        this.addCartEl.setAttribute('data-variant-id', picked[0].dataset.variantId)
      }

      // 查看更多：跟随选中项
      if (this.moreBtnEl && picked.length && picked[0].dataset.url) {
        this.moreBtnEl.setAttribute('href', picked[0].dataset.url)
      }
    }
  })

})();
